var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBackNew1 = function SvgBackNew1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "eGKrCp5XsAQ1",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    viewBox: "0 0 106 156"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "eGKrCp5XsAQ9-fill",
    x1: 90.02,
    x2: 17.069,
    y1: 132.043,
    y2: 24.929,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ9-fill-0",
    offset: "0%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ9-fill-1",
    offset: "33.333%",
    stopColor: "#d1ddf7"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ9-fill-2",
    offset: "66.667%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ9-fill-3",
    offset: "100%",
    stopColor: "#d7e3fb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eGKrCp5XsAQ10-fill",
    x1: 90.02,
    x2: 17.069,
    y1: 132.043,
    y2: 24.929,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ10-fill-0",
    offset: "0%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ10-fill-1",
    offset: "33.333%",
    stopColor: "#d1ddf7"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ10-fill-2",
    offset: "66.667%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ10-fill-3",
    offset: "100%",
    stopColor: "#d7e3fb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eGKrCp5XsAQ11-fill",
    x1: 90.02,
    x2: 17.069,
    y1: 132.043,
    y2: 24.929,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ11-fill-0",
    offset: "0%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ11-fill-1",
    offset: "33.333%",
    stopColor: "#d1ddf7"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ11-fill-2",
    offset: "66.667%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ11-fill-3",
    offset: "100%",
    stopColor: "#d7e3fb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eGKrCp5XsAQ12-fill",
    x1: 90.02,
    x2: 17.069,
    y1: 132.043,
    y2: 24.929,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ12-fill-0",
    offset: "0%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ12-fill-1",
    offset: "33.333%",
    stopColor: "#d1ddf7"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ12-fill-2",
    offset: "66.667%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ12-fill-3",
    offset: "100%",
    stopColor: "#d7e3fb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eGKrCp5XsAQ13-fill",
    x1: 90.02,
    x2: 17.069,
    y1: 132.043,
    y2: 24.929,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ13-fill-0",
    offset: "0%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ13-fill-1",
    offset: "33.333%",
    stopColor: "#d1ddf7"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ13-fill-2",
    offset: "66.667%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ13-fill-3",
    offset: "100%",
    stopColor: "#d7e3fb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eGKrCp5XsAQ14-fill",
    x1: 90.02,
    x2: 17.069,
    y1: 132.043,
    y2: 24.929,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ14-fill-0",
    offset: "0%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ14-fill-1",
    offset: "33.333%",
    stopColor: "#d1ddf7"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ14-fill-2",
    offset: "66.667%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ14-fill-3",
    offset: "100%",
    stopColor: "#d7e3fb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eGKrCp5XsAQ15-fill",
    x1: 90.02,
    x2: 17.069,
    y1: 132.043,
    y2: 24.929,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ15-fill-0",
    offset: "0%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ15-fill-1",
    offset: "33.333%",
    stopColor: "#d1ddf7"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ15-fill-2",
    offset: "66.667%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ15-fill-3",
    offset: "100%",
    stopColor: "#d7e3fb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eGKrCp5XsAQ16-fill",
    x1: 90.02,
    x2: 17.069,
    y1: 132.043,
    y2: 24.929,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ16-fill-0",
    offset: "0%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ16-fill-1",
    offset: "33.333%",
    stopColor: "#d1ddf7"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ16-fill-2",
    offset: "66.667%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ16-fill-3",
    offset: "100%",
    stopColor: "#d7e3fb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eGKrCp5XsAQ17-fill",
    x1: 90.02,
    x2: 17.069,
    y1: 132.043,
    y2: 24.929,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ17-fill-0",
    offset: "0%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ17-fill-1",
    offset: "33.333%",
    stopColor: "#d1ddf7"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ17-fill-2",
    offset: "66.667%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ17-fill-3",
    offset: "100%",
    stopColor: "#d7e3fb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eGKrCp5XsAQ18-fill",
    x1: 90.02,
    x2: 17.069,
    y1: 132.043,
    y2: 24.929,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ18-fill-0",
    offset: "0%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ18-fill-1",
    offset: "33.333%",
    stopColor: "#d1ddf7"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ18-fill-2",
    offset: "66.667%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ18-fill-3",
    offset: "100%",
    stopColor: "#d7e3fb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eGKrCp5XsAQ19-fill",
    x1: 90.02,
    x2: 17.069,
    y1: 132.043,
    y2: 24.929,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ19-fill-0",
    offset: "0%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ19-fill-1",
    offset: "33.333%",
    stopColor: "#d1ddf7"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ19-fill-2",
    offset: "66.667%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ19-fill-3",
    offset: "100%",
    stopColor: "#d7e3fb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eGKrCp5XsAQ20-fill",
    x1: 90.02,
    x2: 17.069,
    y1: 132.043,
    y2: 24.929,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ20-fill-0",
    offset: "0%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ20-fill-1",
    offset: "33.333%",
    stopColor: "#d1ddf7"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ20-fill-2",
    offset: "66.667%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ20-fill-3",
    offset: "100%",
    stopColor: "#d7e3fb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eGKrCp5XsAQ21-fill",
    x1: 90.02,
    x2: 17.069,
    y1: 132.043,
    y2: 24.929,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ21-fill-0",
    offset: "0%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ21-fill-1",
    offset: "33.333%",
    stopColor: "#d1ddf7"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ21-fill-2",
    offset: "66.667%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ21-fill-3",
    offset: "100%",
    stopColor: "#d7e3fb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eGKrCp5XsAQ22-fill",
    x1: 90.02,
    x2: 17.069,
    y1: 132.043,
    y2: 24.929,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ22-fill-0",
    offset: "0%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ22-fill-1",
    offset: "33.333%",
    stopColor: "#d1ddf7"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ22-fill-2",
    offset: "66.667%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ22-fill-3",
    offset: "100%",
    stopColor: "#d7e3fb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eGKrCp5XsAQ23-fill",
    x1: 90.02,
    x2: 17.069,
    y1: 132.043,
    y2: 24.929,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ23-fill-0",
    offset: "0%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ23-fill-1",
    offset: "33.333%",
    stopColor: "#d1ddf7"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ23-fill-2",
    offset: "66.667%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ23-fill-3",
    offset: "100%",
    stopColor: "#d7e3fb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eGKrCp5XsAQ24-fill",
    x1: 90.02,
    x2: 17.069,
    y1: 132.043,
    y2: 24.929,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ24-fill-0",
    offset: "0%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ24-fill-1",
    offset: "33.333%",
    stopColor: "#d1ddf7"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ24-fill-2",
    offset: "66.667%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ24-fill-3",
    offset: "100%",
    stopColor: "#d7e3fb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eGKrCp5XsAQ25-fill",
    x1: 90.02,
    x2: 17.069,
    y1: 132.043,
    y2: 24.929,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ25-fill-0",
    offset: "0%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ25-fill-1",
    offset: "33.333%",
    stopColor: "#d1ddf7"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ25-fill-2",
    offset: "66.667%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ25-fill-3",
    offset: "100%",
    stopColor: "#d7e3fb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eGKrCp5XsAQ26-fill",
    x1: 90.02,
    x2: 17.069,
    y1: 132.043,
    y2: 24.929,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ26-fill-0",
    offset: "0%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ26-fill-1",
    offset: "33.333%",
    stopColor: "#d1ddf7"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ26-fill-2",
    offset: "66.667%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ26-fill-3",
    offset: "100%",
    stopColor: "#d7e3fb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eGKrCp5XsAQ27-fill",
    x1: 90.02,
    x2: 17.069,
    y1: 132.043,
    y2: 24.929,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ27-fill-0",
    offset: "0%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ27-fill-1",
    offset: "33.333%",
    stopColor: "#d1ddf7"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ27-fill-2",
    offset: "66.667%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ27-fill-3",
    offset: "100%",
    stopColor: "#d7e3fb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eGKrCp5XsAQ28-fill",
    x1: 90.02,
    x2: 17.069,
    y1: 132.043,
    y2: 24.929,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ28-fill-0",
    offset: "0%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ28-fill-1",
    offset: "33.333%",
    stopColor: "#d1ddf7"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ28-fill-2",
    offset: "66.667%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ28-fill-3",
    offset: "100%",
    stopColor: "#d7e3fb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eGKrCp5XsAQ29-fill",
    x1: 90.02,
    x2: 17.069,
    y1: 132.043,
    y2: 24.929,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ29-fill-0",
    offset: "0%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ29-fill-1",
    offset: "33.333%",
    stopColor: "#d1ddf7"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ29-fill-2",
    offset: "66.667%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ29-fill-3",
    offset: "100%",
    stopColor: "#d7e3fb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eGKrCp5XsAQ30-fill",
    x1: 90.02,
    x2: 17.069,
    y1: 132.043,
    y2: 24.929,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ30-fill-0",
    offset: "0%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ30-fill-1",
    offset: "33.333%",
    stopColor: "#d1ddf7"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ30-fill-2",
    offset: "66.667%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ30-fill-3",
    offset: "100%",
    stopColor: "#d7e3fb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eGKrCp5XsAQ31-fill",
    x1: 90.02,
    x2: 17.069,
    y1: 132.043,
    y2: 24.929,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ31-fill-0",
    offset: "0%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ31-fill-1",
    offset: "33.333%",
    stopColor: "#d1ddf7"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ31-fill-2",
    offset: "66.667%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ31-fill-3",
    offset: "100%",
    stopColor: "#d7e3fb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eGKrCp5XsAQ32-fill",
    x1: 90.02,
    x2: 17.069,
    y1: 132.043,
    y2: 24.929,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ32-fill-0",
    offset: "0%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ32-fill-1",
    offset: "33.333%",
    stopColor: "#d1ddf7"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ32-fill-2",
    offset: "66.667%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ32-fill-3",
    offset: "100%",
    stopColor: "#d7e3fb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eGKrCp5XsAQ33-fill",
    x1: 90.02,
    x2: 17.069,
    y1: 132.043,
    y2: 24.929,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ33-fill-0",
    offset: "0%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ33-fill-1",
    offset: "33.333%",
    stopColor: "#d1ddf7"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ33-fill-2",
    offset: "66.667%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ33-fill-3",
    offset: "100%",
    stopColor: "#d7e3fb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eGKrCp5XsAQ34-fill",
    x1: 90.02,
    x2: 17.069,
    y1: 132.043,
    y2: 24.929,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ34-fill-0",
    offset: "0%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ34-fill-1",
    offset: "33.333%",
    stopColor: "#d1ddf7"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ34-fill-2",
    offset: "66.667%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ34-fill-3",
    offset: "100%",
    stopColor: "#d7e3fb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eGKrCp5XsAQ35-fill",
    x1: 90.02,
    x2: 17.069,
    y1: 132.043,
    y2: 24.929,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ35-fill-0",
    offset: "0%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ35-fill-1",
    offset: "33.333%",
    stopColor: "#d1ddf7"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ35-fill-2",
    offset: "66.667%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ35-fill-3",
    offset: "100%",
    stopColor: "#d7e3fb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eGKrCp5XsAQ36-fill",
    x1: 90.02,
    x2: 17.069,
    y1: 132.043,
    y2: 24.929,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ36-fill-0",
    offset: "0%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ36-fill-1",
    offset: "33.333%",
    stopColor: "#d1ddf7"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ36-fill-2",
    offset: "66.667%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ36-fill-3",
    offset: "100%",
    stopColor: "#d7e3fb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eGKrCp5XsAQ37-fill",
    x1: 90.02,
    x2: 17.069,
    y1: 132.043,
    y2: 24.929,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ37-fill-0",
    offset: "0%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ37-fill-1",
    offset: "33.333%",
    stopColor: "#d1ddf7"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ37-fill-2",
    offset: "66.667%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ37-fill-3",
    offset: "100%",
    stopColor: "#d7e3fb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eGKrCp5XsAQ38-fill",
    x1: 90.02,
    x2: 17.069,
    y1: 132.043,
    y2: 24.929,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ38-fill-0",
    offset: "0%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ38-fill-1",
    offset: "33.333%",
    stopColor: "#d1ddf7"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ38-fill-2",
    offset: "66.667%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ38-fill-3",
    offset: "100%",
    stopColor: "#d7e3fb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eGKrCp5XsAQ39-fill",
    x1: 90.02,
    x2: 17.069,
    y1: 132.043,
    y2: 24.929,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ39-fill-0",
    offset: "0%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ39-fill-1",
    offset: "33.333%",
    stopColor: "#d1ddf7"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ39-fill-2",
    offset: "66.667%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ39-fill-3",
    offset: "100%",
    stopColor: "#d7e3fb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eGKrCp5XsAQ40-fill",
    x1: 90.02,
    x2: 17.069,
    y1: 132.043,
    y2: 24.929,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ40-fill-0",
    offset: "0%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ40-fill-1",
    offset: "33.333%",
    stopColor: "#d1ddf7"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ40-fill-2",
    offset: "66.667%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ40-fill-3",
    offset: "100%",
    stopColor: "#d7e3fb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eGKrCp5XsAQ41-fill",
    x1: 90.02,
    x2: 17.069,
    y1: 132.043,
    y2: 24.929,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ41-fill-0",
    offset: "0%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ41-fill-1",
    offset: "33.333%",
    stopColor: "#d1ddf7"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ41-fill-2",
    offset: "66.667%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ41-fill-3",
    offset: "100%",
    stopColor: "#d7e3fb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eGKrCp5XsAQ42-fill",
    x1: 90.02,
    x2: 17.069,
    y1: 132.043,
    y2: 24.929,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ42-fill-0",
    offset: "0%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ42-fill-1",
    offset: "33.333%",
    stopColor: "#d1ddf7"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ42-fill-2",
    offset: "66.667%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ42-fill-3",
    offset: "100%",
    stopColor: "#d7e3fb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eGKrCp5XsAQ43-fill",
    x1: 90.02,
    x2: 17.069,
    y1: 132.043,
    y2: 24.929,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ43-fill-0",
    offset: "0%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ43-fill-1",
    offset: "33.333%",
    stopColor: "#d1ddf7"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ43-fill-2",
    offset: "66.667%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ43-fill-3",
    offset: "100%",
    stopColor: "#d7e3fb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eGKrCp5XsAQ44-fill",
    x1: 90.02,
    x2: 17.069,
    y1: 132.043,
    y2: 24.929,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ44-fill-0",
    offset: "0%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ44-fill-1",
    offset: "33.333%",
    stopColor: "#d1ddf7"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ44-fill-2",
    offset: "66.667%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ44-fill-3",
    offset: "100%",
    stopColor: "#d7e3fb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eGKrCp5XsAQ45-fill",
    x1: 90.02,
    x2: 17.069,
    y1: 132.043,
    y2: 24.929,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ45-fill-0",
    offset: "0%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ45-fill-1",
    offset: "33.333%",
    stopColor: "#d1ddf7"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ45-fill-2",
    offset: "66.667%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ45-fill-3",
    offset: "100%",
    stopColor: "#d7e3fb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eGKrCp5XsAQ46-fill",
    x1: 90.02,
    x2: 17.069,
    y1: 132.043,
    y2: 24.929,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ46-fill-0",
    offset: "0%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ46-fill-1",
    offset: "33.333%",
    stopColor: "#d1ddf7"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ46-fill-2",
    offset: "66.667%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ46-fill-3",
    offset: "100%",
    stopColor: "#d7e3fb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eGKrCp5XsAQ47-fill",
    x1: 90.02,
    x2: 17.069,
    y1: 132.043,
    y2: 24.929,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ47-fill-0",
    offset: "0%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ47-fill-1",
    offset: "33.333%",
    stopColor: "#d1ddf7"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ47-fill-2",
    offset: "66.667%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ47-fill-3",
    offset: "100%",
    stopColor: "#d7e3fb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eGKrCp5XsAQ48-fill",
    x1: 90.02,
    x2: 17.069,
    y1: 132.043,
    y2: 24.929,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ48-fill-0",
    offset: "0%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ48-fill-1",
    offset: "33.333%",
    stopColor: "#d1ddf7"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ48-fill-2",
    offset: "66.667%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ48-fill-3",
    offset: "100%",
    stopColor: "#d7e3fb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eGKrCp5XsAQ49-fill",
    x1: 90.02,
    x2: 17.069,
    y1: 132.043,
    y2: 24.929,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ49-fill-0",
    offset: "0%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ49-fill-1",
    offset: "33.333%",
    stopColor: "#d1ddf7"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ49-fill-2",
    offset: "66.667%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ49-fill-3",
    offset: "100%",
    stopColor: "#d7e3fb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eGKrCp5XsAQ50-fill",
    x1: 90.02,
    x2: 17.069,
    y1: 132.043,
    y2: 24.929,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ50-fill-0",
    offset: "0%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ50-fill-1",
    offset: "33.333%",
    stopColor: "#d1ddf7"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ50-fill-2",
    offset: "66.667%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ50-fill-3",
    offset: "100%",
    stopColor: "#d7e3fb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eGKrCp5XsAQ51-fill",
    x1: 90.02,
    x2: 17.069,
    y1: 132.043,
    y2: 24.929,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ51-fill-0",
    offset: "0%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ51-fill-1",
    offset: "33.333%",
    stopColor: "#d1ddf7"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ51-fill-2",
    offset: "66.667%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ51-fill-3",
    offset: "100%",
    stopColor: "#d7e3fb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eGKrCp5XsAQ52-fill",
    x1: 90.02,
    x2: 17.069,
    y1: 132.043,
    y2: 24.929,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ52-fill-0",
    offset: "0%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ52-fill-1",
    offset: "33.333%",
    stopColor: "#d1ddf7"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ52-fill-2",
    offset: "66.667%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ52-fill-3",
    offset: "100%",
    stopColor: "#d7e3fb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eGKrCp5XsAQ53-fill",
    x1: 90.02,
    x2: 17.069,
    y1: 132.043,
    y2: 24.929,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ53-fill-0",
    offset: "0%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ53-fill-1",
    offset: "33.333%",
    stopColor: "#d1ddf7"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ53-fill-2",
    offset: "66.667%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ53-fill-3",
    offset: "100%",
    stopColor: "#d7e3fb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eGKrCp5XsAQ54-fill",
    x1: 90.02,
    x2: 17.069,
    y1: 132.043,
    y2: 24.929,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ54-fill-0",
    offset: "0%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ54-fill-1",
    offset: "33.333%",
    stopColor: "#d1ddf7"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ54-fill-2",
    offset: "66.667%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ54-fill-3",
    offset: "100%",
    stopColor: "#d7e3fb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eGKrCp5XsAQ55-fill",
    x1: 90.02,
    x2: 17.069,
    y1: 132.043,
    y2: 24.929,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ55-fill-0",
    offset: "0%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ55-fill-1",
    offset: "33.333%",
    stopColor: "#d1ddf7"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ55-fill-2",
    offset: "66.667%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ55-fill-3",
    offset: "100%",
    stopColor: "#d7e3fb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eGKrCp5XsAQ56-fill",
    x1: 90.02,
    x2: 17.069,
    y1: 132.043,
    y2: 24.929,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ56-fill-0",
    offset: "0%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ56-fill-1",
    offset: "33.333%",
    stopColor: "#d1ddf7"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ56-fill-2",
    offset: "66.667%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ56-fill-3",
    offset: "100%",
    stopColor: "#d7e3fb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eGKrCp5XsAQ57-fill",
    x1: 90.02,
    x2: 17.069,
    y1: 132.043,
    y2: 24.929,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ57-fill-0",
    offset: "0%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ57-fill-1",
    offset: "33.333%",
    stopColor: "#d1ddf7"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ57-fill-2",
    offset: "66.667%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ57-fill-3",
    offset: "100%",
    stopColor: "#d7e3fb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eGKrCp5XsAQ58-fill",
    x1: 90.02,
    x2: 17.069,
    y1: 132.043,
    y2: 24.929,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ58-fill-0",
    offset: "0%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ58-fill-1",
    offset: "33.333%",
    stopColor: "#d1ddf7"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ58-fill-2",
    offset: "66.667%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ58-fill-3",
    offset: "100%",
    stopColor: "#d7e3fb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eGKrCp5XsAQ59-fill",
    x1: 90.02,
    x2: 17.069,
    y1: 132.043,
    y2: 24.929,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ59-fill-0",
    offset: "0%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ59-fill-1",
    offset: "33.333%",
    stopColor: "#d1ddf7"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ59-fill-2",
    offset: "66.667%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ59-fill-3",
    offset: "100%",
    stopColor: "#d7e3fb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eGKrCp5XsAQ60-fill",
    x1: 90.02,
    x2: 17.069,
    y1: 132.043,
    y2: 24.929,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ60-fill-0",
    offset: "0%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ60-fill-1",
    offset: "33.333%",
    stopColor: "#d1ddf7"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ60-fill-2",
    offset: "66.667%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ60-fill-3",
    offset: "100%",
    stopColor: "#d7e3fb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eGKrCp5XsAQ61-fill",
    x1: 90.02,
    x2: 17.069,
    y1: 132.043,
    y2: 24.929,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ61-fill-0",
    offset: "0%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ61-fill-1",
    offset: "33.333%",
    stopColor: "#d1ddf7"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ61-fill-2",
    offset: "66.667%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ61-fill-3",
    offset: "100%",
    stopColor: "#d7e3fb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eGKrCp5XsAQ62-fill",
    x1: 90.02,
    x2: 17.069,
    y1: 132.043,
    y2: 24.929,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ62-fill-0",
    offset: "0%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ62-fill-1",
    offset: "33.333%",
    stopColor: "#d1ddf7"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ62-fill-2",
    offset: "66.667%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ62-fill-3",
    offset: "100%",
    stopColor: "#d7e3fb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eGKrCp5XsAQ63-fill",
    x1: 90.02,
    x2: 17.069,
    y1: 132.043,
    y2: 24.929,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ63-fill-0",
    offset: "0%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ63-fill-1",
    offset: "33.333%",
    stopColor: "#d1ddf7"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ63-fill-2",
    offset: "66.667%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ63-fill-3",
    offset: "100%",
    stopColor: "#d7e3fb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eGKrCp5XsAQ64-fill",
    x1: 90.02,
    x2: 17.069,
    y1: 132.043,
    y2: 24.929,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ64-fill-0",
    offset: "0%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ64-fill-1",
    offset: "33.333%",
    stopColor: "#d1ddf7"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ64-fill-2",
    offset: "66.667%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ64-fill-3",
    offset: "100%",
    stopColor: "#d7e3fb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eGKrCp5XsAQ65-fill",
    x1: 90.02,
    x2: 17.069,
    y1: 132.043,
    y2: 24.929,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ65-fill-0",
    offset: "0%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ65-fill-1",
    offset: "33.333%",
    stopColor: "#d1ddf7"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ65-fill-2",
    offset: "66.667%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ65-fill-3",
    offset: "100%",
    stopColor: "#d7e3fb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eGKrCp5XsAQ66-fill",
    x1: 90.02,
    x2: 17.069,
    y1: 132.043,
    y2: 24.929,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ66-fill-0",
    offset: "0%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ66-fill-1",
    offset: "33.333%",
    stopColor: "#d1ddf7"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ66-fill-2",
    offset: "66.667%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ66-fill-3",
    offset: "100%",
    stopColor: "#d7e3fb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eGKrCp5XsAQ67-fill",
    x1: 90.02,
    x2: 17.069,
    y1: 132.043,
    y2: 24.929,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ67-fill-0",
    offset: "0%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ67-fill-1",
    offset: "33.333%",
    stopColor: "#d1ddf7"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ67-fill-2",
    offset: "66.667%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ67-fill-3",
    offset: "100%",
    stopColor: "#d7e3fb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eGKrCp5XsAQ68-fill",
    x1: 90.02,
    x2: 17.069,
    y1: 132.043,
    y2: 24.929,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ68-fill-0",
    offset: "0%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ68-fill-1",
    offset: "33.333%",
    stopColor: "#d1ddf7"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ68-fill-2",
    offset: "66.667%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ68-fill-3",
    offset: "100%",
    stopColor: "#d7e3fb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eGKrCp5XsAQ69-fill",
    x1: 90.02,
    x2: 17.069,
    y1: 132.043,
    y2: 24.929,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ69-fill-0",
    offset: "0%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ69-fill-1",
    offset: "33.333%",
    stopColor: "#d1ddf7"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ69-fill-2",
    offset: "66.667%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ69-fill-3",
    offset: "100%",
    stopColor: "#d7e3fb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eGKrCp5XsAQ70-fill",
    x1: 90.02,
    x2: 17.069,
    y1: 132.043,
    y2: 24.929,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ70-fill-0",
    offset: "0%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ70-fill-1",
    offset: "33.333%",
    stopColor: "#d1ddf7"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ70-fill-2",
    offset: "66.667%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ70-fill-3",
    offset: "100%",
    stopColor: "#d7e3fb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eGKrCp5XsAQ71-fill",
    x1: 90.02,
    x2: 17.069,
    y1: 132.043,
    y2: 24.929,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ71-fill-0",
    offset: "0%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ71-fill-1",
    offset: "33.333%",
    stopColor: "#d1ddf7"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ71-fill-2",
    offset: "66.667%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ71-fill-3",
    offset: "100%",
    stopColor: "#d7e3fb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eGKrCp5XsAQ72-fill",
    x1: 90.02,
    x2: 17.069,
    y1: 132.043,
    y2: 24.929,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ72-fill-0",
    offset: "0%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ72-fill-1",
    offset: "33.333%",
    stopColor: "#d1ddf7"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ72-fill-2",
    offset: "66.667%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ72-fill-3",
    offset: "100%",
    stopColor: "#d7e3fb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eGKrCp5XsAQ73-fill",
    x1: 90.02,
    x2: 17.069,
    y1: 132.043,
    y2: 24.929,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ73-fill-0",
    offset: "0%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ73-fill-1",
    offset: "33.333%",
    stopColor: "#d1ddf7"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ73-fill-2",
    offset: "66.667%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ73-fill-3",
    offset: "100%",
    stopColor: "#d7e3fb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eGKrCp5XsAQ74-fill",
    x1: 90.02,
    x2: 17.069,
    y1: 132.043,
    y2: 24.929,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ74-fill-0",
    offset: "0%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ74-fill-1",
    offset: "33.333%",
    stopColor: "#d1ddf7"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ74-fill-2",
    offset: "66.667%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ74-fill-3",
    offset: "100%",
    stopColor: "#d7e3fb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eGKrCp5XsAQ75-fill",
    x1: 90.02,
    x2: 17.069,
    y1: 132.043,
    y2: 24.929,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ75-fill-0",
    offset: "0%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ75-fill-1",
    offset: "33.333%",
    stopColor: "#d1ddf7"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ75-fill-2",
    offset: "66.667%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ75-fill-3",
    offset: "100%",
    stopColor: "#d7e3fb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eGKrCp5XsAQ76-fill",
    x1: 90.02,
    x2: 17.069,
    y1: 132.043,
    y2: 24.929,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ76-fill-0",
    offset: "0%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ76-fill-1",
    offset: "33.333%",
    stopColor: "#d1ddf7"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ76-fill-2",
    offset: "66.667%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ76-fill-3",
    offset: "100%",
    stopColor: "#d7e3fb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eGKrCp5XsAQ77-fill",
    x1: 90.02,
    x2: 17.069,
    y1: 132.043,
    y2: 24.929,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ77-fill-0",
    offset: "0%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ77-fill-1",
    offset: "33.333%",
    stopColor: "#d1ddf7"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ77-fill-2",
    offset: "66.667%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ77-fill-3",
    offset: "100%",
    stopColor: "#d7e3fb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eGKrCp5XsAQ78-fill",
    x1: 90.02,
    x2: 17.069,
    y1: 132.043,
    y2: 24.929,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ78-fill-0",
    offset: "0%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ78-fill-1",
    offset: "33.333%",
    stopColor: "#d1ddf7"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ78-fill-2",
    offset: "66.667%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ78-fill-3",
    offset: "100%",
    stopColor: "#d7e3fb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eGKrCp5XsAQ79-fill",
    x1: 90.02,
    x2: 17.069,
    y1: 132.043,
    y2: 24.929,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ79-fill-0",
    offset: "0%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ79-fill-1",
    offset: "33.333%",
    stopColor: "#d1ddf7"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ79-fill-2",
    offset: "66.667%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ79-fill-3",
    offset: "100%",
    stopColor: "#d7e3fb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eGKrCp5XsAQ80-fill",
    x1: 90.02,
    x2: 17.069,
    y1: 132.043,
    y2: 24.929,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ80-fill-0",
    offset: "0%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ80-fill-1",
    offset: "33.333%",
    stopColor: "#d1ddf7"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ80-fill-2",
    offset: "66.667%",
    stopColor: "#949fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ80-fill-3",
    offset: "100%",
    stopColor: "#d7e3fb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eGKrCp5XsAQ81-stroke",
    x1: 4,
    x2: 108.806,
    y1: -0.397,
    y2: 152.363,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ81-stroke-0",
    offset: "0%",
    stopColor: "#2e344c"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ81-stroke-1",
    offset: "31%",
    stopColor: "#2f354e"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ81-stroke-2",
    offset: "50.5%",
    stopColor: "#6878b1"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ81-stroke-3",
    offset: "71%",
    stopColor: "#303750"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eGKrCp5XsAQ81-stroke-4",
    offset: "100%",
    stopColor: "#313851"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#eGKrCp5XsAQ84)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#333954",
    d: "M92 11a4 4 0 0 0-4-4H18c-2.21 0-4 1.79-4 4s-1.79 4-4 4-4 1.79-4 4v119c0 2.209 1.79 4 4 4s4 1.791 4 4 1.79 4 4 4h70c2.21 0 4-1.791 4-4s1.79-4 4-4 4-1.791 4-4V19c0-2.21-1.79-4-4-4s-4-1.79-4-4"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#eGKrCp5XsAQ8)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#b7c4e2",
    d: "M92 11a4 4 0 0 0-4-4H18a4 4 0 0 0-4 4 4 4 0 0 1-4 4 4 4 0 0 0-4 4v119a4 4 0 0 0 4 4 4 4 0 0 1 4 4 4 4 0 0 0 4 4h70a4 4 0 0 0 4-4 4 4 0 0 1 4-4 4 4 0 0 0 4-4V19a4 4 0 0 0-4-4 4 4 0 0 1-4-4"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "eGKrCp5XsAQ8",
    width: "400%",
    height: "400%",
    x: "-150%",
    y: "-150%",
    "mask-type": "alpha"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#eGKrCp5XsAQ9-fill)",
    d: "m15.5 11.694.124.058a2 2 0 0 0-.143.36q-.072.252-.157.599a30 30 0 0 0-.177.753q-.084.413-.176.837a285 285 0 0 1-.327 1.577q.222-.418.451-.856.229-.444.444-.875l.425-.825q.21-.398.392-.727.183-.335.334-.573.15-.244.254-.367.138 0 .288.007a1.7 1.7 0 0 1 .582.103.55.55 0 0 1 .215.148 8 8 0 0 0-.098.412q-.053.264-.117.605a48.063 48.063 0 0 0-.255 1.506q-.053.38-.098.734-.039.348-.06.612.198-.4.38-.921.183-.528.379-1.081.203-.56.438-1.101c.235-.541.333-.685.53-.972q.195-.065.404-.11.216-.045.425-.038.21 0 .405.058a.9.9 0 0 1 .36.18q-.275.341-.543.772c-.268.431-.355.593-.529.914q-.255.476-.497.992-.235.509-.45 1.017c-.216.508-.277.671-.4.998q-.182.482-.326.914-.177.006-.418.026c-.241.02-.318.01-.47-.007a.9.9 0 0 1-.386-.116q-.157-.09-.17-.315a49 49 0 0 0-.052-.753q-.02-.342-.033-.67c-.013-.328-.013-.446-.013-.682q.006-.354.039-.798a33 33 0 0 1-.7 1.654 34 34 0 0 0-.66 1.545 6 6 0 0 0-.372-.026q-.176 0-.346-.032a1.4 1.4 0 0 1-.327-.09.8.8 0 0 1-.28-.206 5.4 5.4 0 0 1-.06-1.01q.02-.587.085-1.211.072-.63.17-1.23c.098-.6.129-.75.19-1.055q-.543.076-.87.225-.326.142-.51.348a1.3 1.3 0 0 0-.254.476q-.072.264-.098.586h-.262a3 3 0 0 1-.209-.02 1.1 1.1 0 0 1-.313-.102q-.138-.078-.216-.2a.46.46 0 0 1-.085-.29 1.1 1.1 0 0 1 .072-.392q.105-.29.34-.528.236-.245.555-.431.32-.187.713-.31.39-.127.81-.18.419-.057.836-.038.426.019.817.122"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#eGKrCp5XsAQ10-fill)",
    d: "m28.526 13.126 1.561 1.568-1.56 1.568-1.562-1.568z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#eGKrCp5XsAQ11-fill)",
    d: "m40.474 11.694.124.058a2 2 0 0 0-.143.36q-.072.252-.157.599-.085.34-.177.753-.084.413-.176.837a285 285 0 0 1-.327 1.577q.222-.418.451-.856.229-.444.444-.875l.425-.825q.21-.398.392-.727.183-.335.334-.573.15-.244.254-.367.138 0 .288.007a1.7 1.7 0 0 1 .582.103.55.55 0 0 1 .215.148 8 8 0 0 0-.098.412q-.052.264-.117.605a46.974 46.974 0 0 0-.255 1.506q-.053.38-.098.734-.039.348-.06.612.197-.4.38-.921.183-.528.379-1.081a19 19 0 0 1 .438-1.101q.235-.54.53-.972.195-.065.404-.11.216-.045.425-.038.21 0 .405.058a.9.9 0 0 1 .36.18 8 8 0 0 0-.543.772 18 18 0 0 0-1.026 1.906 35 35 0 0 0-.45 1.017q-.216.508-.4.998-.182.482-.326.914-.177.006-.418.026c-.241.02-.318.01-.47-.007a.9.9 0 0 1-.386-.116q-.158-.09-.17-.315a49 49 0 0 0-.053-.753q-.019-.342-.032-.67c-.013-.328-.013-.446-.013-.682q.006-.354.039-.798-.346.882-.7 1.654c-.353.772-.455 1.03-.66 1.545a6 6 0 0 0-.372-.026q-.176 0-.346-.032a1.4 1.4 0 0 1-.327-.09.8.8 0 0 1-.281-.206 5.4 5.4 0 0 1-.059-1.01q.02-.587.085-1.211.072-.63.17-1.23.098-.598.19-1.055-.543.076-.87.225-.326.142-.51.348a1.3 1.3 0 0 0-.254.476q-.072.264-.098.586h-.262a3 3 0 0 1-.209-.02 1.1 1.1 0 0 1-.313-.102q-.138-.078-.216-.2c-.078-.122-.08-.178-.085-.29s.02-.242.072-.392q.105-.29.34-.528.235-.245.555-.431.32-.187.713-.31.39-.127.81-.18.418-.057.836-.038.426.019.817.122"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#eGKrCp5XsAQ12-fill)",
    d: "m53.5 13.126 1.56 1.568-1.56 1.568-1.56-1.568z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#eGKrCp5XsAQ13-fill)",
    d: "m65.448 11.694.124.058a2 2 0 0 0-.144.36q-.071.252-.156.599-.085.34-.177.753-.084.413-.176.837a255 255 0 0 1-.327 1.577q.222-.418.45-.856.23-.444.445-.875l.425-.825q.21-.398.392-.727.183-.335.334-.573.15-.244.254-.367.138 0 .288.007a1.7 1.7 0 0 1 .582.103.55.55 0 0 1 .215.148 8 8 0 0 0-.098.412q-.052.264-.117.605a46.974 46.974 0 0 0-.255 1.506q-.053.38-.098.734-.04.348-.06.612.197-.4.38-.921.183-.528.379-1.081.202-.56.438-1.101c.236-.541.333-.685.529-.972q.196-.065.405-.11.216-.045.425-.038.21 0 .405.058a.9.9 0 0 1 .36.18 8 8 0 0 0-.543.772 18 18 0 0 0-1.026 1.906q-.236.509-.45 1.017-.216.508-.4.998-.182.482-.326.914-.177.006-.418.026c-.241.02-.318.01-.47-.007a.9.9 0 0 1-.387-.116q-.155-.09-.17-.315-.025-.42-.052-.753-.02-.342-.032-.67a15 15 0 0 1-.013-.682q.006-.354.039-.798a33 33 0 0 1-.7 1.654 34 34 0 0 0-.66 1.545 6 6 0 0 0-.372-.026q-.177 0-.346-.032a1.4 1.4 0 0 1-.327-.09.8.8 0 0 1-.281-.206 5.4 5.4 0 0 1-.059-1.01q.02-.587.085-1.211.072-.63.17-1.23.097-.598.19-1.055-.543.076-.87.225-.327.142-.51.348a1.3 1.3 0 0 0-.254.476q-.072.264-.098.586h-.262a3 3 0 0 1-.209-.02 1.1 1.1 0 0 1-.314-.102q-.137-.078-.215-.2a.46.46 0 0 1-.085-.29 1.1 1.1 0 0 1 .072-.392q.105-.29.34-.528.235-.245.555-.431.32-.187.712-.31.393-.127.81-.18.42-.057.837-.038.425.019.817.122"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#eGKrCp5XsAQ14-fill)",
    d: "m78.474 13.126 1.56 1.568-1.56 1.568-1.561-1.568z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#eGKrCp5XsAQ15-fill)",
    d: "m90.422 11.694.124.058a2 2 0 0 0-.144.36q-.072.252-.157.599-.084.34-.176.753-.084.413-.176.837a255 255 0 0 1-.327 1.577q.222-.418.45-.856.23-.444.445-.875l.425-.825q.21-.398.392-.727.183-.335.333-.573.15-.244.255-.367.138 0 .288.007a1.7 1.7 0 0 1 .581.103.55.55 0 0 1 .216.148 8 8 0 0 0-.098.412l-.118.605q-.065.34-.13.734-.066.386-.124.772-.053.38-.098.734-.04.348-.06.612.197-.4.38-.921.183-.528.379-1.081.202-.56.438-1.101c.236-.541.333-.685.529-.972q.196-.065.405-.11.216-.045.425-.038.21 0 .405.058a.9.9 0 0 1 .36.18q-.275.341-.543.772c-.268.431-.355.593-.53.914q-.255.476-.496.992-.236.509-.45 1.017-.217.508-.4.998-.183.482-.326.914-.177.006-.419.026c-.242.02-.318.01-.47-.007a.9.9 0 0 1-.386-.116q-.155-.09-.17-.315-.025-.42-.052-.753-.02-.342-.032-.67a15 15 0 0 1-.014-.682q.007-.354.04-.798-.346.882-.7 1.654c-.354.772-.455 1.03-.66 1.545a6 6 0 0 0-.372-.026q-.177 0-.346-.032a1.4 1.4 0 0 1-.327-.09.8.8 0 0 1-.281-.206 5.4 5.4 0 0 1-.059-1.01q.02-.587.085-1.211.072-.63.17-1.23.097-.598.19-1.055-.543.076-.87.225-.327.142-.51.348a1.3 1.3 0 0 0-.254.476q-.072.264-.098.586h-.262a3 3 0 0 1-.209-.02 1.1 1.1 0 0 1-.314-.102q-.137-.078-.215-.2a.46.46 0 0 1-.085-.29 1.1 1.1 0 0 1 .072-.392q.105-.29.34-.528.234-.245.555-.431.32-.187.712-.31.393-.127.81-.18.42-.057.837-.038.425.019.817.122"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#eGKrCp5XsAQ16-fill)",
    d: "m16.04 27.238 1.56 1.567-1.56 1.568-1.562-1.568z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#eGKrCp5XsAQ17-fill)",
    d: "m27.987 25.806.124.057a2 2 0 0 0-.143.36q-.072.252-.157.6a30 30 0 0 0-.177.753q-.084.411-.176.837a284 284 0 0 1-.327 1.577q.222-.42.451-.856.228-.445.444-.876l.425-.824q.21-.399.392-.727.183-.334.334-.573.15-.245.254-.367.138 0 .288.006a1.7 1.7 0 0 1 .582.103.55.55 0 0 1 .215.148 8 8 0 0 0-.098.412l-.117.605a46.974 46.974 0 0 0-.255 1.506q-.053.381-.098.735-.039.347-.06.611.197-.4.38-.92.183-.528.379-1.082.203-.56.438-1.1c.235-.54.333-.685.53-.973q.195-.064.404-.109.216-.045.425-.039.21 0 .405.058a.9.9 0 0 1 .36.18 8 8 0 0 0-.543.773 18 18 0 0 0-1.026 1.905q-.235.51-.45 1.017-.216.51-.4.998-.182.483-.326.914a10 10 0 0 0-.418.026q-.242.019-.47-.006a.9.9 0 0 1-.386-.116q-.158-.09-.17-.316-.027-.418-.053-.753-.02-.34-.032-.67c-.012-.33-.013-.446-.013-.682q.006-.354.039-.798-.346.883-.7 1.654-.352.773-.66 1.545a6 6 0 0 0-.372-.025q-.177 0-.346-.033a1.4 1.4 0 0 1-.327-.09.8.8 0 0 1-.281-.206 5.4 5.4 0 0 1-.059-1.01q.02-.586.085-1.21.072-.63.17-1.23c.098-.6.129-.75.19-1.056q-.543.078-.87.226-.325.141-.51.347a1.3 1.3 0 0 0-.254.477q-.072.263-.098.585h-.262a3 3 0 0 1-.209-.019 1.1 1.1 0 0 1-.313-.103q-.138-.077-.216-.2a.46.46 0 0 1-.085-.29q-.006-.166.072-.392.105-.29.34-.528.236-.245.555-.43a2.8 2.8 0 0 1 .713-.31 4.3 4.3 0 0 1 .81-.18q.419-.059.836-.039.426.02.817.122"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#eGKrCp5XsAQ18-fill)",
    d: "m41.013 27.238 1.56 1.567-1.56 1.568-1.56-1.568z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#eGKrCp5XsAQ19-fill)",
    d: "m52.961 25.806.124.057a2 2 0 0 0-.143.36q-.072.252-.157.6a30 30 0 0 0-.177.753q-.084.411-.176.837a322 322 0 0 1-.327 1.577q.223-.42.45-.856.23-.445.445-.876l.425-.824q.21-.399.392-.727.183-.334.334-.573.15-.245.254-.367.138 0 .288.006a1.7 1.7 0 0 1 .582.103.55.55 0 0 1 .215.148 8 8 0 0 0-.098.412l-.117.605a48.063 48.063 0 0 0-.255 1.506l-.098.735q-.039.347-.06.611.197-.4.38-.92.183-.528.379-1.082.202-.56.438-1.1c.236-.54.333-.685.53-.973q.195-.064.404-.109.216-.045.425-.039.21 0 .405.058a.9.9 0 0 1 .36.18 8 8 0 0 0-.543.773 18 18 0 0 0-1.026 1.905q-.236.51-.45 1.017-.216.51-.4.998-.182.483-.326.914a10 10 0 0 0-.418.026q-.242.019-.47-.006a.9.9 0 0 1-.386-.116q-.158-.09-.17-.316-.026-.418-.053-.753-.02-.34-.032-.67c-.012-.33-.013-.446-.013-.682q.006-.354.039-.798-.346.883-.7 1.654c-.353.771-.455 1.03-.66 1.545a6 6 0 0 0-.372-.025q-.177 0-.346-.033a1.4 1.4 0 0 1-.327-.09.8.8 0 0 1-.281-.206 5.4 5.4 0 0 1-.059-1.01q.02-.586.085-1.21.072-.63.17-1.23c.098-.6.129-.75.19-1.056q-.543.078-.87.226-.325.141-.51.347a1.3 1.3 0 0 0-.254.477q-.072.263-.098.585h-.262a3 3 0 0 1-.209-.019 1.1 1.1 0 0 1-.313-.103.6.6 0 0 1-.216-.2q-.078-.122-.085-.29c-.007-.167.02-.242.072-.392q.105-.29.34-.528.235-.245.555-.43c.32-.186.451-.228.712-.31a4.3 4.3 0 0 1 .81-.18q.42-.059.837-.039.425.02.817.122"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#eGKrCp5XsAQ20-fill)",
    d: "m65.987 27.238 1.56 1.567-1.56 1.568-1.56-1.568z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#eGKrCp5XsAQ21-fill)",
    d: "m77.935 25.806.124.057a2 2 0 0 0-.144.36q-.072.252-.156.6a30 30 0 0 0-.177.753q-.084.411-.176.837a322 322 0 0 1-.327 1.577l.45-.856q.23-.445.445-.876l.425-.824q.21-.399.392-.727.183-.334.333-.573.15-.245.255-.367.138 0 .288.006a1.7 1.7 0 0 1 .581.103.55.55 0 0 1 .216.148 8 8 0 0 0-.098.412l-.118.605q-.066.34-.13.734-.066.386-.124.773l-.098.734q-.04.347-.06.611.197-.4.38-.92.183-.528.379-1.082.202-.56.438-1.1c.236-.54.333-.685.529-.973q.196-.064.405-.109.216-.045.425-.039.21 0 .405.058a.9.9 0 0 1 .36.18 8 8 0 0 0-.543.773 18 18 0 0 0-1.026 1.905q-.236.51-.45 1.017a25 25 0 0 0-.4.998q-.182.483-.326.914a10 10 0 0 0-.418.026q-.243.019-.471-.006a.9.9 0 0 1-.386-.116q-.155-.09-.17-.316-.025-.418-.052-.753-.02-.34-.032-.67c-.012-.33-.014-.446-.014-.682q.007-.354.04-.798-.346.883-.7 1.654c-.354.771-.455 1.03-.66 1.545a6 6 0 0 0-.372-.025q-.177 0-.346-.033a1.4 1.4 0 0 1-.327-.09.8.8 0 0 1-.281-.206 5.4 5.4 0 0 1-.059-1.01q.02-.586.085-1.21.072-.63.17-1.23c.098-.6.128-.75.19-1.056q-.543.078-.87.226-.327.141-.51.347a1.3 1.3 0 0 0-.254.477q-.072.263-.098.585h-.262a3 3 0 0 1-.209-.019 1.1 1.1 0 0 1-.314-.103.6.6 0 0 1-.215-.2q-.079-.122-.085-.29a.9.9 0 0 1 .072-.392q.105-.29.34-.528.234-.245.555-.43a2.8 2.8 0 0 1 .712-.31 4.3 4.3 0 0 1 .81-.18q.42-.059.837-.039.425.02.817.122"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#eGKrCp5XsAQ22-fill)",
    d: "m90.96 27.238 1.562 1.567-1.561 1.568-1.561-1.568z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#eGKrCp5XsAQ23-fill)",
    d: "m15.5 39.917.124.058a2 2 0 0 0-.143.36q-.072.251-.157.6-.085.34-.177.752-.084.413-.176.837a285 285 0 0 1-.327 1.577q.222-.418.451-.856.229-.444.444-.875l.425-.824q.21-.4.392-.728.183-.335.334-.573.15-.244.254-.367.138 0 .288.007a1.7 1.7 0 0 1 .582.103.55.55 0 0 1 .215.148 8 8 0 0 0-.098.412l-.117.605q-.066.34-.131.734-.066.386-.124.772-.053.38-.098.734-.039.348-.06.612.198-.4.38-.92.183-.529.379-1.082.203-.56.438-1.101c.235-.541.333-.685.53-.972q.195-.065.404-.11.216-.044.425-.038.21 0 .405.058a.9.9 0 0 1 .36.18q-.275.34-.543.773c-.268.433-.355.592-.529.914q-.255.476-.497.991-.235.508-.45 1.017-.216.51-.4.998-.182.483-.326.914a10 10 0 0 0-.418.026q-.242.018-.47-.007a.9.9 0 0 1-.386-.116q-.157-.09-.17-.315a49 49 0 0 0-.052-.753q-.02-.341-.033-.67c-.013-.329-.013-.446-.013-.682q.006-.354.039-.798-.346.883-.7 1.654-.352.773-.66 1.545a6 6 0 0 0-.372-.026q-.176 0-.346-.032a1.4 1.4 0 0 1-.327-.09.8.8 0 0 1-.28-.206 5.4 5.4 0 0 1-.06-1.01q.02-.587.085-1.21.072-.632.17-1.23c.098-.598.129-.751.19-1.056q-.543.077-.87.225-.326.142-.51.348a1.3 1.3 0 0 0-.254.476q-.072.264-.098.586h-.262a3 3 0 0 1-.209-.02 1.1 1.1 0 0 1-.313-.102q-.138-.078-.216-.2a.46.46 0 0 1-.085-.29 1.1 1.1 0 0 1 .072-.392q.105-.29.34-.528.236-.245.555-.431c.32-.186.451-.228.713-.31q.39-.128.81-.18.419-.057.836-.038.426.019.817.122"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#eGKrCp5XsAQ24-fill)",
    d: "m28.526 41.35 1.561 1.567-1.56 1.568-1.562-1.568z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#eGKrCp5XsAQ25-fill)",
    d: "m40.474 39.917.124.058a2 2 0 0 0-.143.36q-.072.251-.157.6-.085.34-.177.752-.084.413-.176.837a285 285 0 0 1-.327 1.577q.222-.418.451-.856.229-.444.444-.875l.425-.824q.21-.4.392-.728.183-.335.334-.573.15-.244.254-.367.138 0 .288.007a1.7 1.7 0 0 1 .582.103.55.55 0 0 1 .215.148 8 8 0 0 0-.098.412l-.117.605q-.066.34-.131.734-.066.386-.124.772-.053.38-.098.734-.039.348-.06.612.197-.4.38-.92.183-.529.379-1.082a19 19 0 0 1 .438-1.101q.235-.54.53-.972.195-.065.404-.11.216-.044.425-.038.21 0 .405.058a.9.9 0 0 1 .36.18 8 8 0 0 0-.543.773 18 18 0 0 0-1.026 1.905q-.236.508-.45 1.017-.216.51-.4.998-.182.483-.326.914a10 10 0 0 0-.418.026q-.242.018-.47-.007a.9.9 0 0 1-.386-.116q-.158-.09-.17-.315a49 49 0 0 0-.053-.753q-.019-.341-.032-.67c-.013-.329-.013-.446-.013-.682q.006-.354.039-.798-.346.883-.7 1.654c-.353.771-.455 1.03-.66 1.545a6 6 0 0 0-.372-.026q-.176 0-.346-.032a1.4 1.4 0 0 1-.327-.09.8.8 0 0 1-.281-.206 5.4 5.4 0 0 1-.059-1.01q.02-.587.085-1.21.072-.632.17-1.23.098-.6.19-1.056-.543.077-.87.225-.326.142-.51.348a1.3 1.3 0 0 0-.254.476q-.072.264-.098.586h-.262a3 3 0 0 1-.209-.02 1.1 1.1 0 0 1-.313-.102q-.138-.078-.216-.2a.46.46 0 0 1-.085-.29 1.1 1.1 0 0 1 .072-.392q.105-.29.34-.528.235-.245.555-.431a2.8 2.8 0 0 1 .713-.31q.39-.128.81-.18.418-.057.836-.038.426.019.817.122"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#eGKrCp5XsAQ26-fill)",
    d: "m53.5 41.35 1.56 1.567-1.56 1.568-1.56-1.568z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#eGKrCp5XsAQ27-fill)",
    d: "m65.448 39.917.124.058a2 2 0 0 0-.144.36q-.071.251-.156.6-.085.34-.177.752-.084.413-.176.837a255 255 0 0 1-.327 1.577q.222-.418.45-.856.23-.444.445-.875l.425-.824q.21-.4.392-.728.183-.335.334-.573.15-.244.254-.367.138 0 .288.007a1.7 1.7 0 0 1 .582.103.55.55 0 0 1 .215.148 8 8 0 0 0-.098.412l-.117.605q-.066.34-.131.734-.066.386-.124.772-.053.38-.098.734-.04.348-.06.612.197-.4.38-.92.183-.529.379-1.082.202-.56.438-1.101c.236-.541.333-.685.529-.972q.196-.065.405-.11.216-.044.425-.038.21 0 .405.058a.9.9 0 0 1 .36.18 8 8 0 0 0-.543.773 18 18 0 0 0-1.026 1.905q-.236.508-.45 1.017-.216.51-.4.998-.182.483-.326.914a10 10 0 0 0-.418.026q-.243.018-.47-.007a.9.9 0 0 1-.387-.116q-.155-.09-.17-.315-.025-.418-.052-.753-.02-.341-.032-.67a15 15 0 0 1-.013-.682q.006-.354.039-.798-.346.883-.7 1.654-.352.773-.66 1.545a6 6 0 0 0-.372-.026q-.177 0-.346-.032a1.4 1.4 0 0 1-.327-.09.8.8 0 0 1-.281-.206 5.4 5.4 0 0 1-.059-1.01q.02-.587.085-1.21.072-.632.17-1.23.097-.6.19-1.056-.543.077-.87.225-.327.142-.51.348a1.3 1.3 0 0 0-.254.476q-.072.264-.098.586h-.262a3 3 0 0 1-.209-.02 1.1 1.1 0 0 1-.314-.102q-.137-.078-.215-.2a.46.46 0 0 1-.085-.29 1.1 1.1 0 0 1 .072-.392q.105-.29.34-.528.235-.245.555-.431a2.8 2.8 0 0 1 .712-.31q.393-.128.81-.18.42-.057.837-.038.425.019.817.122"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#eGKrCp5XsAQ28-fill)",
    d: "m78.474 41.35 1.56 1.567-1.56 1.568-1.561-1.568z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#eGKrCp5XsAQ29-fill)",
    d: "m90.422 39.917.124.058a2 2 0 0 0-.144.36q-.072.251-.157.6-.084.34-.176.752-.084.413-.176.837a255 255 0 0 1-.327 1.577q.222-.418.45-.856.23-.444.445-.875l.425-.824q.21-.4.392-.728.183-.335.333-.573.15-.244.255-.367.138 0 .288.007a1.7 1.7 0 0 1 .581.103.55.55 0 0 1 .216.148 8 8 0 0 0-.098.412l-.118.605q-.065.34-.13.734-.066.386-.124.772-.053.38-.098.734-.04.348-.06.612.197-.4.38-.92.183-.529.379-1.082.202-.56.438-1.101c.236-.541.333-.685.529-.972q.196-.065.405-.11.216-.044.425-.038.21 0 .405.058a.9.9 0 0 1 .36.18q-.275.34-.543.773c-.268.433-.355.592-.53.914q-.255.476-.496.991-.236.508-.45 1.017-.217.51-.4.998-.183.483-.326.914a10 10 0 0 0-.419.026q-.241.018-.47-.007a.9.9 0 0 1-.386-.116q-.155-.09-.17-.315-.025-.418-.052-.753-.02-.341-.032-.67a15 15 0 0 1-.014-.682q.007-.354.04-.798-.346.883-.7 1.654c-.354.771-.455 1.03-.66 1.545a6 6 0 0 0-.372-.026q-.177 0-.346-.032a1.4 1.4 0 0 1-.327-.09.8.8 0 0 1-.281-.206 5.4 5.4 0 0 1-.059-1.01q.02-.587.085-1.21.072-.632.17-1.23.097-.6.19-1.056-.543.077-.87.225-.327.142-.51.348a1.3 1.3 0 0 0-.254.476q-.072.264-.098.586h-.262a3 3 0 0 1-.209-.02 1.1 1.1 0 0 1-.314-.102q-.137-.078-.215-.2a.46.46 0 0 1-.085-.29 1.1 1.1 0 0 1 .072-.392q.105-.29.34-.528.234-.245.555-.431c.32-.186.45-.228.712-.31q.393-.128.81-.18.42-.057.837-.038.425.019.817.122"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#eGKrCp5XsAQ30-fill)",
    d: "m16.04 55.46 1.56 1.569-1.56 1.568-1.562-1.568z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#eGKrCp5XsAQ31-fill)",
    d: "m27.987 54.029.124.058a2 2 0 0 0-.143.36q-.072.25-.157.599-.085.34-.177.753l-.176.837a284 284 0 0 1-.327 1.577q.222-.419.451-.856.228-.444.444-.876l.425-.824q.21-.399.392-.727.183-.334.334-.573.15-.244.254-.367.138 0 .288.006a1.7 1.7 0 0 1 .582.103.55.55 0 0 1 .215.149 8 8 0 0 0-.098.411q-.052.264-.117.606a46.974 46.974 0 0 0-.255 1.506q-.053.38-.098.734-.039.347-.06.611.197-.4.38-.92.183-.528.379-1.082.203-.56.438-1.1c.235-.54.333-.685.53-.972q.195-.065.404-.11.216-.045.425-.039.21 0 .405.058a.9.9 0 0 1 .36.18q-.274.342-.543.773c-.269.431-.355.592-.53.914q-.254.477-.496.992-.235.508-.45 1.017t-.4.997q-.182.483-.326.914a10 10 0 0 0-.418.026q-.242.02-.47-.006a.9.9 0 0 1-.386-.116q-.158-.09-.17-.316-.027-.418-.053-.753-.02-.34-.032-.67a15 15 0 0 1-.013-.682q.006-.354.039-.798-.346.882-.7 1.655-.352.773-.66 1.545a6 6 0 0 0-.372-.026q-.177 0-.346-.032a1.4 1.4 0 0 1-.327-.09.8.8 0 0 1-.281-.206 5.4 5.4 0 0 1-.059-1.011q.02-.585.085-1.21.072-.63.17-1.23c.098-.6.129-.75.19-1.056q-.543.078-.87.226a1.4 1.4 0 0 0-.51.347 1.3 1.3 0 0 0-.254.477q-.072.264-.098.586h-.262a3 3 0 0 1-.209-.02 1.1 1.1 0 0 1-.313-.103.6.6 0 0 1-.216-.2.57.57 0 0 1-.085-.289q-.006-.167.072-.393.105-.29.34-.528a2.5 2.5 0 0 1 .555-.43q.32-.187.713-.31a4.3 4.3 0 0 1 .81-.18q.419-.058.836-.039.426.02.817.123"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#eGKrCp5XsAQ32-fill)",
    d: "m41.013 55.46 1.56 1.569-1.56 1.568-1.56-1.568z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#eGKrCp5XsAQ33-fill)",
    d: "m52.961 54.029.124.058a2 2 0 0 0-.143.36q-.072.25-.157.599-.086.34-.177.753l-.176.837a322 322 0 0 1-.327 1.577q.223-.419.45-.856.23-.444.445-.876l.425-.824q.21-.399.392-.727.183-.334.334-.573.15-.244.254-.367.138 0 .288.006a1.7 1.7 0 0 1 .582.103.55.55 0 0 1 .215.149 8 8 0 0 0-.098.411q-.052.264-.117.606a48.063 48.063 0 0 0-.255 1.506q-.053.38-.098.734-.039.347-.06.611.197-.4.38-.92.183-.528.379-1.082.202-.56.438-1.1c.236-.54.333-.685.53-.972q.195-.065.404-.11.216-.045.425-.039.21 0 .405.058a.9.9 0 0 1 .36.18q-.274.342-.543.773c-.269.431-.355.592-.53.914a21 21 0 0 0-.496.992q-.236.508-.45 1.017-.216.508-.4.997-.182.483-.326.914a10 10 0 0 0-.418.026q-.242.02-.47-.006a.9.9 0 0 1-.386-.116q-.158-.09-.17-.316-.026-.418-.053-.753-.02-.34-.032-.67a15 15 0 0 1-.013-.682q.006-.354.039-.798-.346.882-.7 1.655c-.353.773-.455 1.03-.66 1.545a6 6 0 0 0-.372-.026q-.177 0-.346-.032a1.4 1.4 0 0 1-.327-.09.8.8 0 0 1-.281-.206 5.4 5.4 0 0 1-.059-1.011q.02-.585.085-1.21.072-.63.17-1.23c.098-.6.129-.75.19-1.056q-.543.078-.87.226a1.4 1.4 0 0 0-.51.347 1.3 1.3 0 0 0-.254.477q-.072.264-.098.586h-.262a3 3 0 0 1-.209-.02 1.1 1.1 0 0 1-.313-.103.6.6 0 0 1-.216-.2q-.078-.12-.085-.289c-.007-.169.02-.242.072-.393q.105-.29.34-.528a2.5 2.5 0 0 1 .555-.43q.32-.187.712-.31a4.3 4.3 0 0 1 .81-.18q.42-.058.837-.039.425.02.817.123"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#eGKrCp5XsAQ34-fill)",
    d: "m65.987 55.46 1.56 1.569-1.56 1.568-1.56-1.568z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#eGKrCp5XsAQ35-fill)",
    d: "m77.935 54.029.124.058a2 2 0 0 0-.144.36q-.072.25-.156.599-.085.34-.177.753l-.176.837a322 322 0 0 1-.327 1.577q.222-.419.45-.856.23-.444.445-.876l.425-.824q.21-.399.392-.727.183-.334.333-.573.15-.244.255-.367.138 0 .288.006a1.7 1.7 0 0 1 .581.103.55.55 0 0 1 .216.149 8 8 0 0 0-.098.411l-.118.606q-.066.342-.13.733-.066.386-.124.773-.053.38-.098.734-.04.347-.06.611.197-.4.38-.92.183-.528.379-1.082.202-.56.438-1.1c.236-.54.333-.685.529-.972q.196-.065.405-.11.216-.045.425-.039.21 0 .405.058a.9.9 0 0 1 .36.18q-.275.342-.543.773c-.268.431-.355.592-.53.914q-.255.477-.496.992-.236.508-.45 1.017a25 25 0 0 0-.4.997q-.182.483-.326.914a10 10 0 0 0-.418.026q-.243.02-.471-.006a.9.9 0 0 1-.386-.116q-.155-.09-.17-.316-.025-.418-.052-.753-.02-.34-.032-.67a15 15 0 0 1-.014-.682q.007-.354.04-.798-.346.882-.7 1.655c-.354.773-.455 1.03-.66 1.545a6 6 0 0 0-.372-.026q-.177 0-.346-.032a1.4 1.4 0 0 1-.327-.09.8.8 0 0 1-.281-.206 5.4 5.4 0 0 1-.059-1.011q.02-.585.085-1.21.072-.63.17-1.23c.098-.6.128-.75.19-1.056q-.543.078-.87.226a1.4 1.4 0 0 0-.51.347 1.3 1.3 0 0 0-.254.477q-.072.264-.098.586h-.262a3 3 0 0 1-.209-.02 1.1 1.1 0 0 1-.314-.103.6.6 0 0 1-.215-.2q-.079-.12-.085-.289c-.006-.169.02-.242.072-.393q.105-.29.34-.528.234-.244.555-.43.32-.187.712-.31.393-.129.81-.18.42-.058.837-.039.425.02.817.123"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#eGKrCp5XsAQ36-fill)",
    d: "m90.96 55.46 1.562 1.569-1.561 1.568-1.561-1.568z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#eGKrCp5XsAQ37-fill)",
    d: "m15.5 68.14.124.058a2 2 0 0 0-.143.36q-.072.252-.157.6-.085.34-.177.752-.084.413-.176.837a272 272 0 0 1-.327 1.577q.222-.418.451-.856.229-.444.444-.875l.425-.824q.21-.4.392-.728.183-.335.334-.572.15-.246.254-.367.138 0 .288.006.157 0 .3.026.15.026.282.077c.132.051.159.084.215.148a8 8 0 0 0-.098.412l-.117.605q-.066.341-.131.734-.066.387-.124.772-.053.38-.098.734-.039.348-.06.612.198-.4.38-.92.183-.529.379-1.082.203-.56.438-1.1c.235-.54.333-.685.53-.973q.195-.065.404-.11.216-.044.425-.038.21 0 .405.058a.9.9 0 0 1 .36.18 8 8 0 0 0-.543.773 18 18 0 0 0-1.026 1.905q-.235.51-.45 1.017-.216.51-.4.998-.182.483-.326.914a10 10 0 0 0-.418.026q-.242.019-.47-.007a.9.9 0 0 1-.386-.116q-.157-.09-.17-.315a49 49 0 0 0-.052-.753q-.02-.34-.033-.67a17 17 0 0 1-.013-.682q.006-.354.039-.798-.346.882-.7 1.654-.352.773-.66 1.545a6 6 0 0 0-.372-.025q-.176 0-.346-.033a1.4 1.4 0 0 1-.327-.09.8.8 0 0 1-.28-.206 5.4 5.4 0 0 1-.06-1.01q.02-.586.085-1.21.072-.632.17-1.23c.098-.598.129-.751.19-1.056q-.543.078-.87.225-.326.142-.51.348a1.3 1.3 0 0 0-.254.476q-.072.264-.098.586h-.262a3 3 0 0 1-.209-.02 1.1 1.1 0 0 1-.313-.102q-.138-.078-.216-.2a.46.46 0 0 1-.085-.29 1.1 1.1 0 0 1 .072-.392q.105-.29.34-.528a2.5 2.5 0 0 1 .555-.431q.32-.187.713-.31.39-.127.81-.18.419-.056.836-.038.426.02.817.122"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#eGKrCp5XsAQ38-fill)",
    d: "m28.526 69.572 1.561 1.568-1.56 1.568-1.562-1.568z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#eGKrCp5XsAQ39-fill)",
    d: "m40.474 68.14.124.058a2 2 0 0 0-.143.36q-.072.252-.157.6-.085.34-.177.752-.084.413-.176.837a272 272 0 0 1-.327 1.577q.222-.418.451-.856.229-.444.444-.875l.425-.824q.21-.4.392-.728.183-.335.334-.572.15-.246.254-.367.138 0 .288.006.157 0 .3.026.15.026.282.077c.132.051.159.084.215.148a8 8 0 0 0-.098.412l-.117.605a46.962 46.962 0 0 0-.255 1.506q-.053.38-.098.734-.039.348-.06.612.197-.4.38-.92.183-.529.379-1.082.202-.56.438-1.1.235-.541.53-.973.195-.065.404-.11.216-.044.425-.038.21 0 .405.058a.9.9 0 0 1 .36.18 8 8 0 0 0-.543.773 18 18 0 0 0-1.026 1.905q-.236.51-.45 1.017-.216.51-.4.998-.182.483-.326.914a10 10 0 0 0-.418.026q-.242.019-.47-.007a.9.9 0 0 1-.386-.116q-.158-.09-.17-.315a49 49 0 0 0-.053-.753q-.019-.34-.032-.67a17 17 0 0 1-.013-.682q.006-.354.039-.798-.346.882-.7 1.654c-.353.772-.455 1.03-.66 1.545a6 6 0 0 0-.372-.025q-.176 0-.346-.033a1.4 1.4 0 0 1-.327-.09.8.8 0 0 1-.281-.206 5.4 5.4 0 0 1-.059-1.01q.02-.586.085-1.21.072-.632.17-1.23.098-.6.19-1.056-.543.078-.87.225-.326.142-.51.348a1.3 1.3 0 0 0-.254.476q-.072.264-.098.586h-.262a3 3 0 0 1-.209-.02 1.1 1.1 0 0 1-.313-.102q-.138-.078-.216-.2a.46.46 0 0 1-.085-.29 1.1 1.1 0 0 1 .072-.392q.105-.29.34-.528a2.5 2.5 0 0 1 .555-.431q.32-.187.713-.31a4.3 4.3 0 0 1 .81-.18q.418-.056.836-.038.426.02.817.122"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#eGKrCp5XsAQ40-fill)",
    d: "m53.5 69.572 1.56 1.568-1.56 1.568-1.56-1.568z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#eGKrCp5XsAQ41-fill)",
    d: "m65.448 68.14.124.058a2 2 0 0 0-.144.36q-.071.252-.156.6-.085.34-.177.752-.084.413-.176.837a244 244 0 0 1-.327 1.577q.222-.418.45-.856.23-.444.445-.875l.425-.824q.21-.4.392-.728.183-.335.334-.572.15-.246.254-.367.138 0 .288.006.157 0 .3.026.15.026.282.077c.132.051.159.084.215.148a8 8 0 0 0-.098.412l-.117.605a46.962 46.962 0 0 0-.255 1.506q-.053.38-.098.734-.04.348-.06.612.197-.4.38-.92.183-.529.379-1.082.202-.56.438-1.1c.236-.54.333-.685.529-.973q.196-.065.405-.11.216-.044.425-.038.21 0 .405.058a.9.9 0 0 1 .36.18 8 8 0 0 0-.543.773 18 18 0 0 0-1.026 1.905q-.236.51-.45 1.017-.216.51-.4.998-.182.483-.326.914-.177.006-.418.026-.243.019-.47-.007a.9.9 0 0 1-.387-.116q-.155-.09-.17-.315-.025-.419-.052-.753-.02-.34-.032-.67a17 17 0 0 1-.013-.682q.006-.354.039-.798-.346.882-.7 1.654-.352.773-.66 1.545a6 6 0 0 0-.372-.025q-.177 0-.346-.033a1.4 1.4 0 0 1-.327-.09.8.8 0 0 1-.281-.206 5.4 5.4 0 0 1-.059-1.01q.02-.586.085-1.21.072-.632.17-1.23.097-.6.19-1.056-.543.078-.87.225-.327.142-.51.348a1.3 1.3 0 0 0-.254.476q-.072.264-.098.586h-.262a3 3 0 0 1-.209-.02 1.1 1.1 0 0 1-.314-.102q-.137-.078-.215-.2a.46.46 0 0 1-.085-.29 1.1 1.1 0 0 1 .072-.392q.105-.29.34-.528.235-.245.555-.431.32-.187.712-.31a4.3 4.3 0 0 1 .81-.18q.42-.056.837-.038.425.02.817.122"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#eGKrCp5XsAQ42-fill)",
    d: "m78.474 69.572 1.56 1.568-1.56 1.568-1.561-1.568z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#eGKrCp5XsAQ43-fill)",
    d: "m90.422 68.14.124.058a2 2 0 0 0-.144.36q-.072.252-.157.6-.084.34-.176.752-.084.413-.176.837a244 244 0 0 1-.327 1.577q.222-.418.45-.856.23-.444.445-.875l.425-.824q.21-.4.392-.728.183-.335.333-.572.15-.246.255-.367.138 0 .288.006.157 0 .3.026.15.026.281.077c.131.051.16.084.216.148a8 8 0 0 0-.098.412l-.118.605q-.065.341-.13.734-.066.387-.124.772-.053.38-.098.734-.04.348-.06.612.197-.4.38-.92.183-.529.379-1.082.202-.56.438-1.1c.236-.54.333-.685.529-.973q.196-.065.405-.11.216-.044.425-.038.21 0 .405.058a.9.9 0 0 1 .36.18 8 8 0 0 0-.543.773 18 18 0 0 0-1.026 1.905q-.236.51-.45 1.017-.217.51-.4.998-.183.483-.326.914-.177.006-.419.026-.241.019-.47-.007a.9.9 0 0 1-.386-.116q-.155-.09-.17-.315-.025-.419-.052-.753-.02-.34-.032-.67a17 17 0 0 1-.014-.682q.007-.354.04-.798-.346.882-.7 1.654c-.354.772-.455 1.03-.66 1.545a6 6 0 0 0-.372-.025q-.177 0-.346-.033a1.4 1.4 0 0 1-.327-.09.8.8 0 0 1-.281-.206 5.4 5.4 0 0 1-.059-1.01q.02-.586.085-1.21.072-.632.17-1.23.097-.6.19-1.056-.543.078-.87.225a1.4 1.4 0 0 0-.51.348 1.3 1.3 0 0 0-.254.476q-.072.264-.098.586h-.262a3 3 0 0 1-.209-.02 1.1 1.1 0 0 1-.314-.102q-.137-.078-.215-.2a.46.46 0 0 1-.085-.29 1.1 1.1 0 0 1 .072-.392q.105-.29.34-.528.234-.245.555-.431.32-.187.712-.31a4.3 4.3 0 0 1 .81-.18q.42-.056.837-.038.425.02.817.122"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#eGKrCp5XsAQ44-fill)",
    d: "m16.04 83.684 1.56 1.568-1.56 1.568-1.562-1.568z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#eGKrCp5XsAQ45-fill)",
    d: "m27.987 82.252.124.058a2 2 0 0 0-.143.36q-.072.252-.157.599-.085.34-.177.753-.084.413-.176.837a271 271 0 0 1-.327 1.577q.222-.418.451-.856.228-.444.444-.876l.425-.823q.21-.4.392-.728.183-.335.334-.573.15-.244.254-.367.138 0 .288.007.157 0 .3.025.15.026.282.078c.132.052.159.083.215.148a8 8 0 0 0-.098.412q-.052.263-.117.605-.066.34-.131.734-.066.386-.124.772-.053.38-.098.734-.039.348-.06.611.197-.398.38-.92.183-.528.379-1.082.203-.56.438-1.1t.53-.972q.195-.065.404-.11.216-.045.425-.038.21 0 .405.058a.9.9 0 0 1 .36.18q-.274.341-.543.772c-.269.431-.355.593-.53.914q-.254.477-.496.992-.235.509-.45 1.017t-.4.998q-.182.482-.326.914-.177.006-.418.025c-.241.02-.318.011-.47-.006a.9.9 0 0 1-.386-.116q-.158-.09-.17-.315-.027-.42-.053-.753-.02-.342-.032-.67a17 17 0 0 1-.013-.682q.006-.354.039-.798-.346.881-.7 1.654-.352.772-.66 1.545a6 6 0 0 0-.372-.026 2 2 0 0 1-.346-.032 1.4 1.4 0 0 1-.327-.09.8.8 0 0 1-.281-.206 5.4 5.4 0 0 1-.059-1.01q.02-.587.085-1.211.072-.63.17-1.23c.098-.6.129-.75.19-1.055q-.543.077-.87.225a1.4 1.4 0 0 0-.51.348 1.3 1.3 0 0 0-.254.476q-.072.264-.098.586h-.262a3 3 0 0 1-.209-.02 1.1 1.1 0 0 1-.313-.103q-.138-.077-.216-.2a.46.46 0 0 1-.085-.289q-.006-.167.072-.393.105-.29.34-.527.236-.245.555-.432.32-.186.713-.309a4.3 4.3 0 0 1 .81-.18q.419-.058.836-.039.426.02.817.123"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#eGKrCp5XsAQ46-fill)",
    d: "m41.013 83.684 1.56 1.568-1.56 1.568-1.56-1.568z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#eGKrCp5XsAQ47-fill)",
    d: "m52.961 82.252.124.058a2 2 0 0 0-.143.36q-.072.252-.157.599-.086.34-.177.753-.084.413-.176.837a306 306 0 0 1-.327 1.577q.223-.418.45-.856.23-.444.445-.876l.425-.823q.21-.4.392-.728.183-.335.334-.573.15-.244.254-.367.138 0 .288.007.157 0 .3.025.15.026.282.078c.132.052.159.083.215.148a8 8 0 0 0-.098.412q-.052.263-.117.605-.066.34-.131.734-.066.386-.124.772-.053.38-.098.734-.039.348-.06.611.197-.398.38-.92.183-.528.379-1.082.202-.56.438-1.1.235-.54.53-.972.195-.065.404-.11.216-.045.425-.038.21 0 .405.058a.9.9 0 0 1 .36.18q-.274.341-.543.772c-.269.431-.355.593-.53.914q-.255.477-.496.992-.236.509-.45 1.017-.216.508-.4.998-.182.482-.326.914a10 10 0 0 0-.418.025q-.242.02-.47-.006a.9.9 0 0 1-.386-.116q-.158-.09-.17-.315-.026-.42-.053-.753-.02-.342-.032-.67a17 17 0 0 1-.013-.682q.006-.354.039-.798-.346.881-.7 1.654c-.353.773-.455 1.03-.66 1.545a6 6 0 0 0-.372-.026q-.177 0-.346-.032a1.4 1.4 0 0 1-.327-.09.8.8 0 0 1-.281-.206 5.4 5.4 0 0 1-.059-1.01q.02-.587.085-1.211.072-.63.17-1.23c.098-.6.129-.75.19-1.055q-.543.077-.87.225a1.4 1.4 0 0 0-.51.348 1.3 1.3 0 0 0-.254.476q-.072.264-.098.586h-.262a3 3 0 0 1-.209-.02 1.1 1.1 0 0 1-.313-.103.6.6 0 0 1-.216-.2q-.078-.12-.085-.289c-.007-.169.02-.242.072-.393q.105-.29.34-.527.235-.245.555-.432.32-.186.712-.309a4.3 4.3 0 0 1 .81-.18q.42-.058.837-.039.425.02.817.123"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#eGKrCp5XsAQ48-fill)",
    d: "m65.987 83.684 1.56 1.568-1.56 1.568-1.56-1.568z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#eGKrCp5XsAQ49-fill)",
    d: "m77.935 82.252.124.058a2 2 0 0 0-.144.36q-.072.252-.156.599-.085.34-.177.753-.084.413-.176.837a306 306 0 0 1-.327 1.577q.222-.418.45-.856.23-.444.445-.876l.425-.823q.21-.4.392-.728.183-.335.333-.573.15-.244.255-.367.138 0 .288.007.157 0 .3.025.15.026.281.078c.131.052.16.083.216.148a8 8 0 0 0-.098.412l-.118.605q-.065.34-.13.734-.066.386-.124.772-.053.38-.098.734-.04.348-.06.611.197-.398.38-.92.183-.528.379-1.082.202-.56.438-1.1.234-.54.529-.972.196-.065.405-.11.216-.045.425-.038.21 0 .405.058a.9.9 0 0 1 .36.18q-.275.341-.543.772c-.268.431-.355.593-.53.914q-.255.477-.496.992-.236.509-.45 1.017-.217.508-.4.998-.182.482-.326.914-.177.006-.418.025c-.241.02-.319.011-.471-.006a.9.9 0 0 1-.386-.116q-.155-.09-.17-.315-.025-.42-.052-.753-.02-.342-.032-.67a17 17 0 0 1-.014-.682q.007-.354.04-.798-.346.881-.7 1.654c-.354.773-.455 1.03-.66 1.545a6 6 0 0 0-.372-.026q-.177 0-.346-.032a1.4 1.4 0 0 1-.327-.09.8.8 0 0 1-.281-.206 5.4 5.4 0 0 1-.059-1.01q.02-.587.085-1.211.072-.63.17-1.23c.098-.6.128-.75.19-1.055q-.543.077-.87.225a1.4 1.4 0 0 0-.51.348 1.3 1.3 0 0 0-.254.476q-.072.264-.098.586h-.262a3 3 0 0 1-.209-.02 1.1 1.1 0 0 1-.314-.103.6.6 0 0 1-.215-.2q-.079-.12-.085-.289c-.006-.169.02-.242.072-.393q.105-.29.34-.527a2.5 2.5 0 0 1 .555-.432q.32-.186.712-.309.393-.128.81-.18.42-.058.837-.039.425.02.817.123"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#eGKrCp5XsAQ50-fill)",
    d: "m90.96 83.684 1.562 1.568-1.561 1.568-1.561-1.568z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#eGKrCp5XsAQ51-fill)",
    d: "m16.04 97.795 1.56 1.568-1.56 1.568-1.562-1.568z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#eGKrCp5XsAQ52-fill)",
    d: "m27.987 96.363.124.058a2 2 0 0 0-.143.36q-.072.252-.157.6-.085.34-.177.753-.084.411-.176.837a271 271 0 0 1-.327 1.577q.222-.419.451-.856.228-.445.444-.876l.425-.824q.21-.399.392-.727.183-.334.334-.573.15-.245.254-.367.138 0 .288.006.157 0 .3.026.15.026.282.077c.132.051.159.084.215.148a8 8 0 0 0-.098.412l-.117.605q-.066.341-.131.734-.066.386-.124.773-.053.38-.098.734a16 16 0 0 0-.06.611q.197-.4.38-.92.183-.528.379-1.082.203-.56.438-1.1a6 6 0 0 1 .53-.973q.195-.065.404-.11.216-.044.425-.038.21 0 .405.058a.9.9 0 0 1 .36.18q-.274.341-.543.773c-.269.432-.355.592-.53.914q-.254.477-.496.991-.235.51-.45 1.017-.216.509-.4.998-.182.483-.326.914-.177.007-.418.026a2 2 0 0 1-.47-.006.9.9 0 0 1-.386-.116q-.158-.09-.17-.316-.027-.418-.053-.753-.02-.34-.032-.669a15 15 0 0 1-.013-.683q.006-.354.039-.798-.346.883-.7 1.654-.352.773-.66 1.545a6 6 0 0 0-.372-.025q-.177 0-.346-.033a1.4 1.4 0 0 1-.327-.09.8.8 0 0 1-.281-.206 5.4 5.4 0 0 1-.059-1.01q.02-.586.085-1.21.072-.63.17-1.23c.098-.6.129-.751.19-1.056q-.543.078-.87.226a1.4 1.4 0 0 0-.51.347 1.3 1.3 0 0 0-.254.477q-.072.263-.098.585h-.262a3 3 0 0 1-.209-.019 1.1 1.1 0 0 1-.313-.103q-.138-.077-.216-.2a.46.46 0 0 1-.085-.29q-.006-.166.072-.392.105-.29.34-.528.236-.245.555-.431a3.4 3.4 0 0 1 .713-.309 4.3 4.3 0 0 1 .81-.18q.419-.059.836-.039.426.02.817.122"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#eGKrCp5XsAQ53-fill)",
    d: "m41.013 97.795 1.56 1.568-1.56 1.568-1.56-1.568z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#eGKrCp5XsAQ54-fill)",
    d: "m52.961 96.363.124.058a2 2 0 0 0-.143.36q-.072.252-.157.6-.086.34-.177.753-.084.411-.176.837a306 306 0 0 1-.327 1.577q.223-.419.45-.856.23-.445.445-.876l.425-.824q.21-.399.392-.727.183-.334.334-.573.15-.245.254-.367.138 0 .288.006.157 0 .3.026.15.026.282.077c.132.051.159.084.215.148a8 8 0 0 0-.098.412l-.117.605q-.066.341-.131.734-.066.386-.124.773-.053.38-.098.734a16 16 0 0 0-.06.611q.197-.4.38-.92.183-.528.379-1.082.202-.56.438-1.1a6 6 0 0 1 .53-.973q.195-.065.404-.11.216-.044.425-.038.21 0 .405.058a.9.9 0 0 1 .36.18q-.274.341-.543.773c-.269.432-.355.592-.53.914q-.255.477-.496.991a35 35 0 0 0-.45 1.017q-.216.509-.4.998-.182.483-.326.914-.177.007-.418.026a2.5 2.5 0 0 1-.47-.006.9.9 0 0 1-.386-.116q-.158-.09-.17-.316-.026-.418-.053-.753-.02-.34-.032-.669a15 15 0 0 1-.013-.683q.006-.354.039-.798-.346.883-.7 1.654-.352.773-.66 1.545a6 6 0 0 0-.372-.025q-.177 0-.346-.033a1.4 1.4 0 0 1-.327-.09.8.8 0 0 1-.281-.206 5.4 5.4 0 0 1-.059-1.01q.02-.586.085-1.21.072-.63.17-1.23c.098-.6.129-.751.19-1.056q-.543.078-.87.226a1.4 1.4 0 0 0-.51.347 1.3 1.3 0 0 0-.254.477q-.072.263-.098.585h-.262a3 3 0 0 1-.209-.019 1.1 1.1 0 0 1-.313-.103.6.6 0 0 1-.216-.2q-.078-.122-.085-.29c-.007-.167.02-.242.072-.392q.105-.29.34-.528.235-.245.555-.431t.712-.309a4.3 4.3 0 0 1 .81-.18q.42-.059.837-.039.425.02.817.122"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#eGKrCp5XsAQ55-fill)",
    d: "m65.987 97.795 1.56 1.568-1.56 1.568-1.56-1.568z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#eGKrCp5XsAQ56-fill)",
    d: "m77.935 96.363.124.058a2 2 0 0 0-.144.36q-.072.252-.156.6-.085.34-.177.753-.084.411-.176.837a306 306 0 0 1-.327 1.577q.222-.419.45-.856.23-.445.445-.876l.425-.824q.21-.399.392-.727.183-.334.333-.573.15-.245.255-.367.138 0 .288.006.157 0 .3.026.15.026.281.077c.131.051.16.084.216.148a8 8 0 0 0-.098.412l-.118.605q-.065.341-.13.734-.066.386-.124.773-.053.38-.098.734a16 16 0 0 0-.06.611q.197-.4.38-.92.183-.528.379-1.082.202-.56.438-1.1a6 6 0 0 1 .529-.973q.196-.065.405-.11.216-.044.425-.038.21 0 .405.058a.9.9 0 0 1 .36.18q-.275.341-.543.773c-.268.432-.355.592-.53.914q-.255.477-.496.991a35 35 0 0 0-.45 1.017q-.217.509-.4.998-.182.483-.326.914-.177.007-.418.026a2 2 0 0 1-.471-.006.9.9 0 0 1-.386-.116q-.155-.09-.17-.316-.025-.418-.052-.753-.02-.34-.032-.669a15 15 0 0 1-.014-.683q.007-.354.04-.798-.346.883-.7 1.654a33 33 0 0 0-.66 1.545 6 6 0 0 0-.372-.025q-.177 0-.346-.033a1.4 1.4 0 0 1-.327-.09.8.8 0 0 1-.281-.206 5.4 5.4 0 0 1-.059-1.01q.02-.586.085-1.21.072-.63.17-1.23c.098-.6.128-.751.19-1.056q-.543.078-.87.226a1.4 1.4 0 0 0-.51.347 1.3 1.3 0 0 0-.254.477q-.072.263-.098.585h-.262a3 3 0 0 1-.209-.019 1.1 1.1 0 0 1-.314-.103.6.6 0 0 1-.215-.2q-.079-.122-.085-.29a.9.9 0 0 1 .072-.392q.105-.29.34-.528.234-.245.555-.431.32-.186.712-.309.393-.129.81-.18.42-.059.837-.039.425.02.817.122"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#eGKrCp5XsAQ57-fill)",
    d: "m90.96 97.795 1.562 1.568-1.561 1.568-1.561-1.568z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#eGKrCp5XsAQ58-fill)",
    d: "m3.552 111.907 1.561 1.568-1.56 1.568-1.562-1.568z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#eGKrCp5XsAQ59-fill)",
    d: "m15.5 110.475.124.058a2 2 0 0 0-.143.36q-.072.251-.157.599-.085.342-.177.753l-.176.837a299 299 0 0 1-.327 1.577q.222-.418.451-.856.229-.444.444-.875l.425-.824q.21-.4.392-.728.183-.335.334-.573.15-.244.254-.367.138 0 .288.007a1.6 1.6 0 0 1 .582.103.55.55 0 0 1 .215.148 8 8 0 0 0-.098.412l-.117.605q-.065.34-.131.734-.066.386-.124.772l-.098.734a16 16 0 0 0-.06.612q.198-.399.38-.921.183-.528.379-1.081.203-.561.438-1.101.235-.541.53-.972.195-.064.404-.11.216-.044.425-.038.21 0 .405.058a.9.9 0 0 1 .36.18 8 8 0 0 0-.543.772 18 18 0 0 0-1.026 1.906q-.235.509-.45 1.017c-.216.508-.277.672-.4.998a24 24 0 0 0-.326.914 9 9 0 0 0-.418.026q-.242.018-.47-.007a.9.9 0 0 1-.386-.116q-.157-.09-.17-.315-.027-.418-.052-.753-.02-.342-.033-.67c-.013-.328-.013-.446-.013-.682q.006-.354.039-.798-.346.882-.7 1.654a34 34 0 0 0-.66 1.545 6 6 0 0 0-.372-.026q-.176 0-.346-.032a1.4 1.4 0 0 1-.327-.09.8.8 0 0 1-.28-.206 5.4 5.4 0 0 1-.06-1.011q.02-.585.085-1.21.072-.63.17-1.229t.19-1.056q-.543.077-.87.225-.326.142-.51.348a1.3 1.3 0 0 0-.254.476q-.072.264-.098.586h-.262a1.144 1.144 0 0 1-.523-.122.566.566 0 0 1-.3-.49q-.006-.167.072-.392a1.45 1.45 0 0 1 .34-.528q.236-.245.555-.431a3.4 3.4 0 0 1 .713-.309q.39-.129.81-.181.419-.057.836-.038.426.019.817.122"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#eGKrCp5XsAQ60-fill)",
    d: "m28.526 111.907 1.561 1.568-1.56 1.568-1.562-1.568z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#eGKrCp5XsAQ61-fill)",
    d: "m40.474 110.475.124.058a2 2 0 0 0-.143.36q-.072.251-.157.599-.085.342-.177.753l-.176.837a299 299 0 0 1-.327 1.577q.222-.418.451-.856.229-.444.444-.875l.425-.824q.21-.4.392-.728.183-.335.334-.573.15-.244.254-.367.138 0 .288.007a1.6 1.6 0 0 1 .582.103.55.55 0 0 1 .215.148 8 8 0 0 0-.098.412l-.117.605q-.066.34-.131.734-.066.386-.124.772l-.098.734a16 16 0 0 0-.06.612q.197-.399.38-.921.183-.528.379-1.081.202-.561.438-1.101.235-.541.53-.972.195-.064.404-.11.216-.044.425-.038.21 0 .405.058a.9.9 0 0 1 .36.18 8 8 0 0 0-.543.772 18 18 0 0 0-1.026 1.906q-.236.509-.45 1.017a25 25 0 0 0-.4.998 24 24 0 0 0-.326.914 9 9 0 0 0-.418.026q-.242.018-.47-.007a.9.9 0 0 1-.386-.116q-.158-.09-.17-.315-.026-.418-.053-.753-.019-.342-.032-.67c-.013-.328-.013-.446-.013-.682q.006-.354.039-.798-.346.882-.7 1.654c-.353.772-.455 1.03-.66 1.545a6 6 0 0 0-.372-.026q-.176 0-.346-.032a1.4 1.4 0 0 1-.327-.09.8.8 0 0 1-.281-.206 5.4 5.4 0 0 1-.059-1.011q.02-.585.085-1.21.072-.63.17-1.229t.19-1.056q-.543.077-.87.225-.326.142-.51.348a1.3 1.3 0 0 0-.254.476q-.072.264-.098.586h-.262a1.142 1.142 0 0 1-.523-.122.566.566 0 0 1-.3-.49q-.006-.167.072-.392a1.45 1.45 0 0 1 .34-.528q.235-.245.555-.431.32-.187.713-.309a4.3 4.3 0 0 1 .81-.181q.418-.057.836-.038.426.019.817.122"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#eGKrCp5XsAQ62-fill)",
    d: "m53.5 111.907 1.56 1.568-1.56 1.568-1.56-1.568z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#eGKrCp5XsAQ63-fill)",
    d: "m65.448 110.475.124.058a2 2 0 0 0-.144.36q-.071.251-.156.599-.085.342-.177.753l-.176.837a267 267 0 0 1-.327 1.577q.222-.418.45-.856.23-.444.445-.875l.425-.824q.21-.4.392-.728.183-.335.334-.573.15-.244.254-.367.138 0 .288.007a1.6 1.6 0 0 1 .582.103.55.55 0 0 1 .215.148 8 8 0 0 0-.098.412l-.117.605q-.066.34-.131.734-.066.386-.124.772-.053.38-.098.734a16 16 0 0 0-.06.612q.197-.399.38-.921.183-.528.379-1.081.202-.561.438-1.101.235-.541.529-.972.196-.064.405-.11.216-.044.425-.038.21 0 .405.058a.9.9 0 0 1 .36.18 8 8 0 0 0-.543.772 18 18 0 0 0-1.026 1.906q-.236.509-.45 1.017a25 25 0 0 0-.4.998q-.182.482-.326.914a9 9 0 0 0-.418.026q-.243.018-.47-.007a.9.9 0 0 1-.387-.116q-.155-.09-.17-.315-.025-.418-.052-.753-.02-.342-.032-.67a15 15 0 0 1-.013-.682q.006-.354.039-.798-.346.882-.7 1.654a34 34 0 0 0-.66 1.545 6 6 0 0 0-.372-.026q-.177 0-.346-.032a1.4 1.4 0 0 1-.327-.09.8.8 0 0 1-.281-.206 5.4 5.4 0 0 1-.059-1.011q.02-.585.085-1.21.072-.63.17-1.229.097-.6.19-1.056-.543.077-.87.225-.327.142-.51.348a1.3 1.3 0 0 0-.254.476q-.072.264-.098.586h-.262a1.143 1.143 0 0 1-.523-.122.565.565 0 0 1-.3-.49q-.007-.167.072-.392a1.45 1.45 0 0 1 .34-.528q.235-.245.555-.431.32-.187.712-.309a4.3 4.3 0 0 1 .81-.181q.42-.057.837-.038.425.019.817.122"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#eGKrCp5XsAQ64-fill)",
    d: "m78.474 111.907 1.56 1.568-1.56 1.568-1.561-1.568z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#eGKrCp5XsAQ65-fill)",
    d: "m90.422 110.475.124.058a2 2 0 0 0-.144.36q-.072.251-.157.599-.084.342-.176.753-.084.413-.176.837a267 267 0 0 1-.327 1.577q.222-.418.45-.856.23-.444.445-.875l.425-.824q.21-.4.392-.728.183-.335.333-.573.15-.244.255-.367.138 0 .288.007a1.6 1.6 0 0 1 .581.103.55.55 0 0 1 .216.148 8 8 0 0 0-.098.412l-.118.605q-.065.34-.13.734-.066.386-.124.772-.053.38-.098.734a16 16 0 0 0-.06.612q.197-.399.38-.921.183-.528.379-1.081.202-.561.438-1.101.234-.541.529-.972.196-.064.405-.11.216-.044.425-.038.21 0 .405.058a.9.9 0 0 1 .36.18 8 8 0 0 0-.543.772 18 18 0 0 0-1.026 1.906q-.236.509-.45 1.017-.217.509-.4.998-.183.482-.326.914a9 9 0 0 0-.419.026q-.241.018-.47-.007a.9.9 0 0 1-.386-.116q-.155-.09-.17-.315-.025-.418-.052-.753-.02-.342-.032-.67a15 15 0 0 1-.014-.682q.007-.354.04-.798-.346.882-.7 1.654c-.354.772-.455 1.03-.66 1.545a6 6 0 0 0-.372-.026q-.177 0-.346-.032a1.4 1.4 0 0 1-.327-.09.8.8 0 0 1-.281-.206 5.4 5.4 0 0 1-.059-1.011q.02-.585.085-1.21.072-.63.17-1.229.097-.6.19-1.056-.543.077-.87.225-.327.142-.51.348a1.3 1.3 0 0 0-.254.476q-.072.264-.098.586h-.262a1.143 1.143 0 0 1-.523-.122.565.565 0 0 1-.3-.49q-.007-.167.072-.392a1.45 1.45 0 0 1 .34-.528q.234-.245.555-.431.32-.187.712-.309a4.3 4.3 0 0 1 .81-.181q.42-.057.837-.038.425.019.817.122"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#eGKrCp5XsAQ66-fill)",
    d: "m103.448 111.907 1.561 1.568-1.561 1.568-1.561-1.568z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#eGKrCp5XsAQ67-fill)",
    d: "m16.04 126.019 1.56 1.568-1.56 1.567-1.562-1.567z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#eGKrCp5XsAQ68-fill)",
    d: "m27.987 124.587.124.058a2 2 0 0 0-.143.36q-.072.25-.157.599a29 29 0 0 0-.177.753q-.084.412-.176.837a298 298 0 0 1-.327 1.577q.222-.419.451-.856.228-.444.444-.876l.425-.824q.21-.399.392-.727.183-.335.334-.573.15-.244.254-.367.138 0 .288.006a1.7 1.7 0 0 1 .582.103.6.6 0 0 1 .215.148 8 8 0 0 0-.098.412q-.052.264-.117.606-.066.341-.131.733-.066.387-.124.773-.053.38-.098.734-.039.347-.06.611.197-.4.38-.92.183-.528.379-1.082.203-.56.438-1.1.235-.541.53-.972.195-.065.404-.11a1.8 1.8 0 0 1 .83.019.9.9 0 0 1 .36.181 8 8 0 0 0-.543.772 18 18 0 0 0-1.026 1.906q-.235.509-.45 1.017c-.216.508-.277.671-.4.997q-.182.483-.326.914-.177.007-.418.026a2 2 0 0 1-.47-.006.9.9 0 0 1-.386-.116q-.158-.09-.17-.316-.027-.418-.053-.753-.02-.34-.032-.669a15 15 0 0 1-.013-.683q.006-.354.039-.798a33 33 0 0 1-.7 1.655q-.352.772-.66 1.545a5 5 0 0 0-.372-.026q-.177 0-.346-.032a1.5 1.5 0 0 1-.327-.09.8.8 0 0 1-.281-.206 5.4 5.4 0 0 1-.059-1.011q.02-.586.085-1.21.072-.632.17-1.23c.098-.598.129-.751.19-1.056q-.543.078-.87.226-.325.141-.51.347a1.3 1.3 0 0 0-.254.477q-.072.264-.098.586h-.262a3 3 0 0 1-.209-.02 1.1 1.1 0 0 1-.313-.103.6.6 0 0 1-.216-.199.57.57 0 0 1-.085-.29q-.006-.167.072-.393a1.45 1.45 0 0 1 .34-.528q.236-.244.555-.431.32-.186.713-.309.39-.129.81-.18.419-.059.836-.039.426.02.817.123"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#eGKrCp5XsAQ69-fill)",
    d: "m41.013 126.019 1.56 1.568-1.56 1.567-1.56-1.567z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#eGKrCp5XsAQ70-fill)",
    d: "m52.961 124.587.124.058a2 2 0 0 0-.143.36q-.072.25-.157.599a29 29 0 0 0-.177.753q-.084.412-.176.837l-.327 1.577q.223-.419.45-.856.23-.444.445-.876l.425-.824q.21-.399.392-.727.183-.335.334-.573.15-.244.254-.367.138 0 .288.006a1.7 1.7 0 0 1 .582.103.6.6 0 0 1 .215.148 8 8 0 0 0-.098.412q-.052.264-.117.606-.066.341-.131.733-.066.387-.124.773l-.098.734q-.039.347-.06.611.197-.4.38-.92.183-.528.379-1.082.202-.56.438-1.1.235-.541.53-.972.195-.065.404-.11a1.8 1.8 0 0 1 .83.019.9.9 0 0 1 .36.181 8 8 0 0 0-.543.772 18 18 0 0 0-1.026 1.906q-.236.509-.45 1.017c-.215.508-.277.671-.4.997q-.182.483-.326.914-.177.007-.418.026a2.5 2.5 0 0 1-.47-.006.9.9 0 0 1-.386-.116q-.158-.09-.17-.316-.026-.418-.053-.753-.02-.34-.032-.669a15 15 0 0 1-.013-.683q.006-.354.039-.798-.346.882-.7 1.655c-.353.773-.455 1.03-.66 1.545a5 5 0 0 0-.372-.026q-.177 0-.346-.032a1.5 1.5 0 0 1-.327-.09.8.8 0 0 1-.281-.206 5.4 5.4 0 0 1-.059-1.011q.02-.586.085-1.21.072-.632.17-1.23c.098-.598.129-.751.19-1.056q-.543.078-.87.226-.325.141-.51.347a1.3 1.3 0 0 0-.254.477q-.072.264-.098.586h-.262a3 3 0 0 1-.209-.02 1.1 1.1 0 0 1-.313-.103.6.6 0 0 1-.216-.199q-.078-.122-.085-.29c-.007-.168.02-.242.072-.393a1.45 1.45 0 0 1 .34-.528q.235-.244.555-.431.32-.186.712-.309.393-.129.81-.18.42-.059.837-.039.425.02.817.123"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#eGKrCp5XsAQ71-fill)",
    d: "m65.987 126.019 1.56 1.568-1.56 1.567-1.56-1.567z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#eGKrCp5XsAQ72-fill)",
    d: "m77.935 124.587.124.058a2 2 0 0 0-.144.36q-.072.25-.156.599a29 29 0 0 0-.177.753q-.084.412-.176.837l-.327 1.577q.222-.419.45-.856.23-.444.445-.876l.425-.824q.21-.399.392-.727.183-.335.333-.573.15-.244.255-.367.138 0 .288.006a1.7 1.7 0 0 1 .581.103.56.56 0 0 1 .216.148 8 8 0 0 0-.098.412l-.118.606q-.065.341-.13.733-.066.387-.124.773l-.098.734q-.04.347-.06.611.197-.4.38-.92.183-.528.379-1.082.202-.56.438-1.1.234-.541.529-.972.196-.065.405-.11a1.8 1.8 0 0 1 .83.019.9.9 0 0 1 .36.181 8 8 0 0 0-.543.772 18 18 0 0 0-1.026 1.906q-.236.509-.45 1.017c-.215.508-.278.671-.4.997q-.182.483-.326.914-.177.007-.418.026a2 2 0 0 1-.471-.006.9.9 0 0 1-.386-.116q-.155-.09-.17-.316-.025-.418-.052-.753-.02-.34-.032-.669a15 15 0 0 1-.014-.683q.007-.354.04-.798-.346.882-.7 1.655c-.354.773-.455 1.03-.66 1.545a5 5 0 0 0-.372-.026q-.177 0-.346-.032a1.5 1.5 0 0 1-.327-.09.8.8 0 0 1-.281-.206 5.4 5.4 0 0 1-.059-1.011q.02-.586.085-1.21.072-.632.17-1.23c.098-.598.128-.751.19-1.056q-.543.078-.87.226-.327.141-.51.347a1.3 1.3 0 0 0-.254.477q-.072.264-.098.586h-.262a3 3 0 0 1-.209-.02 1.1 1.1 0 0 1-.314-.103.6.6 0 0 1-.215-.199q-.079-.122-.085-.29a.9.9 0 0 1 .072-.393 1.45 1.45 0 0 1 .34-.528q.234-.244.555-.431.32-.186.712-.309a4.2 4.2 0 0 1 .81-.18q.42-.059.837-.039.425.02.817.123"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#eGKrCp5XsAQ73-fill)",
    d: "m90.96 126.019 1.562 1.568-1.561 1.567-1.561-1.567z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#eGKrCp5XsAQ74-fill)",
    d: "m15.5 138.698.124.058a1.8 1.8 0 0 0-.143.361 16 16 0 0 0-.157.598q-.085.342-.177.753l-.176.837a299 299 0 0 1-.327 1.577q.222-.418.451-.856.229-.444.444-.875l.425-.824q.21-.4.392-.728.183-.335.334-.572.15-.246.254-.367.138 0 .288.006a1.7 1.7 0 0 1 .582.103.55.55 0 0 1 .215.148 8 8 0 0 0-.098.412l-.117.605q-.066.341-.131.734-.066.386-.124.772-.053.38-.098.734a16 16 0 0 0-.06.612q.198-.399.38-.921.183-.528.379-1.081.203-.56.438-1.101a6 6 0 0 1 .53-.972q.195-.064.404-.109.216-.045.425-.039.21 0 .405.058a.9.9 0 0 1 .36.18 8 8 0 0 0-.543.773 17 17 0 0 0-1.026 1.905q-.235.508-.45 1.017a20 20 0 0 0-.4.998 24 24 0 0 0-.326.914q-.177.006-.418.026c-.241.02-.318.011-.47-.007a.9.9 0 0 1-.386-.116q-.157-.09-.17-.315-.027-.419-.052-.753a38 38 0 0 1-.033-.67 17 17 0 0 1-.013-.682q.006-.354.039-.798-.346.882-.7 1.654a34 34 0 0 0-.66 1.545 6 6 0 0 0-.372-.026q-.176 0-.346-.032a1.4 1.4 0 0 1-.327-.09.8.8 0 0 1-.28-.206 5.4 5.4 0 0 1-.06-1.011q.02-.585.085-1.21.072-.63.17-1.229c.098-.599.129-.751.19-1.056q-.543.078-.87.225a1.44 1.44 0 0 0-.51.348 1.3 1.3 0 0 0-.254.476q-.072.264-.098.586h-.262a1.144 1.144 0 0 1-.523-.122.565.565 0 0 1-.3-.489 1.1 1.1 0 0 1 .072-.393 1.45 1.45 0 0 1 .34-.528q.236-.245.555-.431a3.4 3.4 0 0 1 .713-.309 4.2 4.2 0 0 1 .81-.18q.419-.058.836-.039.426.02.817.122"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#eGKrCp5XsAQ75-fill)",
    d: "m28.526 140.13 1.561 1.568-1.56 1.568-1.562-1.568z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#eGKrCp5XsAQ76-fill)",
    d: "m40.474 138.698.124.058a1.8 1.8 0 0 0-.143.361q-.072.251-.157.598-.085.342-.177.753l-.176.837a299 299 0 0 1-.327 1.577q.222-.418.451-.856.229-.444.444-.875l.425-.824q.21-.4.392-.728.183-.335.334-.572.15-.246.254-.367.138 0 .288.006a1.7 1.7 0 0 1 .582.103.55.55 0 0 1 .215.148 8 8 0 0 0-.098.412l-.117.605q-.066.341-.131.734-.066.386-.124.772-.053.38-.098.734a16 16 0 0 0-.06.612q.197-.399.38-.921.183-.528.379-1.081.202-.56.438-1.101.235-.54.53-.972.195-.064.404-.109.216-.045.425-.039.21 0 .405.058a.9.9 0 0 1 .36.18 8 8 0 0 0-.543.773 18 18 0 0 0-1.026 1.905q-.236.508-.45 1.017a25 25 0 0 0-.4.998 24 24 0 0 0-.326.914q-.177.006-.418.026c-.241.02-.318.011-.47-.007a.9.9 0 0 1-.386-.116q-.158-.09-.17-.315-.026-.419-.053-.753a39 39 0 0 1-.032-.67 17 17 0 0 1-.013-.682q.006-.354.039-.798-.346.882-.7 1.654c-.353.772-.455 1.03-.66 1.545a6 6 0 0 0-.372-.026q-.176 0-.346-.032a1.4 1.4 0 0 1-.327-.09.8.8 0 0 1-.281-.206 5.4 5.4 0 0 1-.059-1.011q.02-.585.085-1.21.072-.63.17-1.229t.19-1.056q-.543.078-.87.225a1.44 1.44 0 0 0-.51.348 1.3 1.3 0 0 0-.254.476q-.072.264-.098.586h-.262a1.142 1.142 0 0 1-.523-.122.565.565 0 0 1-.3-.489 1.1 1.1 0 0 1 .072-.393 1.45 1.45 0 0 1 .34-.528q.235-.245.555-.431.32-.187.713-.309.39-.129.81-.18.418-.058.836-.039.426.02.817.122"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#eGKrCp5XsAQ77-fill)",
    d: "m53.5 140.13 1.56 1.568-1.56 1.568-1.56-1.568z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#eGKrCp5XsAQ78-fill)",
    d: "m65.448 138.698.124.058a1.8 1.8 0 0 0-.144.361q-.071.251-.156.598-.085.342-.177.753l-.176.837a267 267 0 0 1-.327 1.577q.222-.418.45-.856.23-.444.445-.875l.425-.824q.21-.4.392-.728.183-.335.334-.572.15-.246.254-.367.138 0 .288.006a1.7 1.7 0 0 1 .582.103.55.55 0 0 1 .215.148 8 8 0 0 0-.098.412l-.117.605q-.066.341-.131.734-.066.386-.124.772-.053.38-.098.734a16 16 0 0 0-.06.612q.197-.399.38-.921.183-.528.379-1.081.202-.56.438-1.101.235-.54.529-.972.196-.064.405-.109.216-.045.425-.039.21 0 .405.058a.9.9 0 0 1 .36.18 8 8 0 0 0-.543.773 17 17 0 0 0-1.026 1.905q-.236.508-.45 1.017a25 25 0 0 0-.4.998q-.182.483-.326.914-.177.006-.418.026c-.241.02-.318.011-.47-.007a.9.9 0 0 1-.387-.116q-.155-.09-.17-.315-.025-.419-.052-.753a40 40 0 0 1-.032-.67 17 17 0 0 1-.013-.682q.006-.354.039-.798-.346.882-.7 1.654a34 34 0 0 0-.66 1.545 6 6 0 0 0-.372-.026q-.177 0-.346-.032a1.4 1.4 0 0 1-.327-.09.8.8 0 0 1-.281-.206 5.4 5.4 0 0 1-.059-1.011q.02-.585.085-1.21.072-.63.17-1.229.097-.599.19-1.056-.543.078-.87.225a1.4 1.4 0 0 0-.51.348 1.3 1.3 0 0 0-.254.476q-.072.264-.098.586h-.262a1.143 1.143 0 0 1-.523-.122.564.564 0 0 1-.3-.489 1.1 1.1 0 0 1 .072-.393 1.45 1.45 0 0 1 .34-.528q.235-.245.555-.431.32-.187.712-.309.393-.129.81-.18.42-.058.837-.039.425.02.817.122"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#eGKrCp5XsAQ79-fill)",
    d: "m78.474 140.13 1.56 1.568-1.56 1.568-1.561-1.568z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#eGKrCp5XsAQ80-fill)",
    d: "m90.422 138.698.124.058a2 2 0 0 0-.144.361q-.072.251-.157.598-.084.342-.176.753-.084.412-.176.837a267 267 0 0 1-.327 1.577q.222-.418.45-.856.23-.444.445-.875l.425-.824q.21-.4.392-.728.183-.335.333-.572.15-.246.255-.367.138 0 .288.006a1.7 1.7 0 0 1 .581.103.55.55 0 0 1 .216.148 8 8 0 0 0-.098.412l-.118.605a46.915 46.915 0 0 0-.255 1.506q-.052.38-.097.734a16 16 0 0 0-.06.612q.197-.399.38-.921.183-.528.379-1.081.202-.56.438-1.101.234-.54.529-.972.196-.064.405-.109a1.8 1.8 0 0 1 .425-.039q.21 0 .405.058a.9.9 0 0 1 .36.18 8 8 0 0 0-.543.773 18 18 0 0 0-1.026 1.905q-.236.508-.45 1.017-.217.509-.4.998-.183.483-.326.914-.177.006-.419.026c-.242.02-.318.011-.47-.007a.9.9 0 0 1-.386-.116q-.155-.09-.17-.315-.025-.419-.052-.753a38 38 0 0 1-.032-.67 17 17 0 0 1-.014-.682q.007-.354.04-.798-.346.882-.7 1.654c-.354.772-.455 1.03-.66 1.545a6 6 0 0 0-.372-.026q-.177 0-.346-.032a1.4 1.4 0 0 1-.327-.09.8.8 0 0 1-.281-.206 5.4 5.4 0 0 1-.059-1.011q.02-.585.085-1.21.072-.63.17-1.229.097-.599.19-1.056-.543.078-.87.225a1.44 1.44 0 0 0-.51.348 1.3 1.3 0 0 0-.254.476q-.072.264-.098.586h-.262a1.143 1.143 0 0 1-.523-.122.564.564 0 0 1-.3-.489 1.1 1.1 0 0 1 .072-.393 1.45 1.45 0 0 1 .34-.528q.234-.245.555-.431.32-.187.712-.309.393-.129.81-.18.42-.058.837-.039.425.02.817.122"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#eGKrCp5XsAQ81-stroke)",
    d: "M88 7.5a3.5 3.5 0 0 1 3.5 3.5 4.5 4.5 0 0 0 4.5 4.5 3.5 3.5 0 0 1 3.5 3.5v119a3.5 3.5 0 0 1-3.5 3.5 4.5 4.5 0 0 0-4.5 4.5 3.5 3.5 0 0 1-3.5 3.5H18a3.5 3.5 0 0 1-3.5-3.5 4.5 4.5 0 0 0-4.5-4.5 3.5 3.5 0 0 1-3.5-3.5V19a3.5 3.5 0 0 1 3.5-3.5 4.5 4.5 0 0 0 4.5-4.5A3.5 3.5 0 0 1 18 7.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#b6c3e2",
    stroke: "#333954",
    strokeWidth: 3,
    d: "m49.827 57.508.122.057.849.394 1.512.702-.858 1.43c-.2.334-.484 1.004-.832 2.113q-.48 1.665-1.052 3.998l-.001.006q-.574 2.295-1.195 5.075a662 662 0 0 1-1.238 5.853q.562-1.106 1.11-2.2l.005-.008.004-.008 2.903-5.606.005-.008a220 220 0 0 1 2.695-4.978 75 75 0 0 1 2.318-3.965c.697-1.13 1.324-2.036 1.875-2.678l.449-.523h.689q.959 0 1.998.044 1.174.002 2.28.198 1.162.197 2.21.606a5.26 5.26 0 0 1 2.05 1.41l.539.611-.218.785a54 54 0 0 0-.647 2.707 670 670 0 0 0-.8 4.094q-.442 2.3-.886 4.956v.004q-.172 1.01-.338 2.021l.705-1.987.004-.01q1.401-3.854 3.027-7.577 1.656-3.793 3.755-6.859l.287-.42.484-.158q1.417-.463 2.92-.785l.01-.002a14 14 0 0 1 3.23-.295 11.3 11.3 0 0 1 3.143.448 7.75 7.75 0 0 1 3.01 1.511l1.154.944-.937 1.16q-1.811 2.24-3.601 5.107a119 119 0 0 0-3.57 6.138 143 143 0 0 0-3.356 6.666 233 233 0 0 0-3.06 6.871 168 168 0 0 0-2.7 6.728l-.002.006a162 162 0 0 0-2.212 6.16l-.33.986-1.038.037q-1.164.043-2.794.172-1.778.142-3.483-.046c-1.186-.105-2.278-.42-3.24-.984-1.257-.723-1.823-1.97-1.905-3.352q-.178-2.835-.355-5.098l-.001-.015-.001-.015q-.135-2.334-.225-4.581-.04-.987-.062-2.006a204 204 0 0 1-1.676 3.754 226 226 0 0 0-4.48 10.44l-.42 1.05-1.125-.113q-1.235-.126-2.421-.168a14.2 14.2 0 0 1-2.591-.24 11.2 11.2 0 0 1-2.55-.703l-.01-.005-.01-.004c-.91-.388-1.719-.992-2.432-1.762l-.304-.327-.075-.44c-.348-2.049-.484-4.44-.423-7.161v-.017q.136-4.042.589-8.34v-.013h.001q.495-4.326 1.171-8.437.455-2.762.89-5.09c-1.4.292-2.54.646-3.437 1.051l-.012.005-.01.005c-1.34.578-2.298 1.25-2.95 1.977a7.1 7.1 0 0 0-1.427 2.66c-.297 1.09-.506 2.32-.618 3.698L29.8 76.54h-3.21l-.041-.002a19 19 0 0 1-1.556-.143l-.03-.005-.03-.005a9.2 9.2 0 0 1-2.56-.842l-.025-.013-.023-.013a5.6 5.6 0 0 1-2.002-1.854c-.523-.812-.78-1.738-.818-2.724-.04-1.009.179-2.095.574-3.225l.003-.008.003-.008c.555-1.533 1.452-2.91 2.66-4.13 1.175-1.214 2.55-2.273 4.115-3.181q2.346-1.36 5.165-2.234a30.7 30.7 0 0 1 5.8-1.285 32.8 32.8 0 0 1 5.978-.273zm0 0-.13-.034m.13.034-.13-.034m0 0a28.3 28.3 0 0 0-5.893-.88z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "eGKrCp5XsAQ84"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 106,
    height: 156,
    fill: "#fff",
    fillOpacity: 0,
    rx: 8,
    ry: 8
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#1e263e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.293 145.707a1 1 0 0 1 1.414 0l1.586 1.586a1 1 0 0 1 0 1.414l-1.586 1.586a1 1 0 0 1-1.414 0l-1.586-1.586a1 1 0 0 1 0-1.414zM6.293 145.707c.39-.39 1.024-.39 1.414 0l1.586 1.586a1 1 0 0 1 0 1.414l-1.586 1.586c-.39.39-1.024.39-1.414 0l-1.586-1.586a1 1 0 0 1 0-1.414zM6.293 4.707a1 1 0 0 1 1.414 0l1.586 1.586a1 1 0 0 1 0 1.414L7.707 9.293a1 1 0 0 1-1.414 0L4.707 7.707a1 1 0 0 1 0-1.414zM98.293 4.707a1 1 0 0 1 1.414 0l1.586 1.586c.39.39.39 1.024 0 1.414l-1.586 1.586a1 1 0 0 1-1.414 0l-1.586-1.586a1 1 0 0 1 0-1.414z"
  }))));
};
export default SvgBackNew1;